<template>
  <div class="l-container AgreementsIndex">

    <span>
      現在表示数 {{max}}
    </span>
    <!-- <div>{{obj}}</div> -->

    <i class="fa fa-sort-alpha-desc"></i>ソート<i class="fa fa-fw fa-angle-down"></i>

    <span>
      <template v-if="this.sortColumn === 'tag_id'">タグ</template>
      <template v-if="this.sortColumn === 'payroll_check'">給与計算チェック</template>
      <template v-if="this.sortColumn === 'id'">ID</template>
      <template v-if="this.sortColumn === 'student_id'">生徒ID</template>
      <template v-if="this.sortColumn === 'office_id'">営業所</template>
      <template v-if="this.sortColumn === 'user_id'">登録者</template>
      <template v-if="this.sortColumn === 'contract_type'">契約種類</template>
      <template v-if="this.sortColumn === 'contract_date_start'">契約日付</template>
      <template v-if="this.sortColumn === 'contract_date_end'">~契約日付</template>
      <template v-if="this.sortColumn === 'change_date'">内容変更日付</template>
      <template v-if="this.sortColumn === 'cancel_type'">解約種類</template>
      <template v-if="this.sortColumn === 'cancel_date'">解約日付</template>
      <template v-if="this.sortColumn === 'f_name'">苗字</template>
      <template v-if="this.sortColumn === 'l_name'">名前</template>
      <template v-if="this.sortColumn === 'f_name_kana'">苗字かな</template>
      <template v-if="this.sortColumn === 'l_name_kana'">名前かな</template>
      <template v-if="this.sortColumn === 'tel1'">携帯TEL</template>
      <template v-if="this.sortColumn === 'tel2'">固定</template>
      <template v-if="this.sortColumn === 'address'">住所</template>
      <template v-if="this.sortColumn === 'address2'">住所2</template>
      <template v-if="this.sortColumn === 'person'">担当者</template>
      <template v-if="this.sortColumn === 'product_name'">商品名</template>
      <template v-if="this.sortColumn === 'payment_type'">支払方法種別</template>
      <template v-if="this.sortColumn === 'text_type'">テキスト種類</template>
      <template v-if="this.sortColumn === 'payments_number'">支払回数</template>
      <template v-if="this.sortColumn === 'text_payment_period_start'">支払期間/開始(テキスト)</template>
      <template v-if="this.sortColumn === 'text_payment_period_end'">支払期間/終了(テキスト)</template>
       : {{sortState}}
    </span>

    <span style="position: absolute; text-align: right; right: 15px" title="役務終了が未来で継続中の家庭は今のところではあるが100%とみなす。中途になった場合は役務終了予定だった未来まで含めて%を確定させる。">
      継続率 {{digestibility}}%
    </span>

    <h1 class="m-label m-label-custom" @click="switchV('column')" v-bind:class="{ 'slideActive': column }" v-ripple>項目</h1>
    <template v-if="column">
      <div style="display: flex; flex-wrap: wrap">
        <btn class="m-btn--column" @click.native="reset()">RESET</btn>
        <btn class="m-btn--column" @click.native="all()">ALL</btn>
        <btn class="m-btn--column" @click.native="def()">DEFAULT</btn>
        <btn class="m-btn--column" @click.native="ad()">AD給与計算</btn>
        <btn class="m-btn--column" @click.native="ledger()">経理</btn>
        <btn class="m-btn--column" @click.native="switchV('tag_id')" v-bind:class="{ 'active': tag_id }">タグ</btn>
        <btn class="m-btn--column" @click.native="switchV('payroll_check')" v-bind:class="{ 'active': payroll_check }">給与計算チェック</btn>
        <btn class="m-btn--column" @click.native="switchV('id')" v-bind:class="{ 'active': id }">ID</btn>
        <btn class="m-btn--column" @click.native="switchV('student_id')" v-bind:class="{ 'active': student_id }">生徒ID</btn>
        <btn class="m-btn--column" @click.native="switchV('office_id')" v-bind:class="{ 'active': office_id }">営業所</btn>
        <btn class="m-btn--column" @click.native="switchV('user_id')" v-bind:class="{ 'active': user_id }">登録者</btn>
        <btn class="m-btn--column" @click.native="switchV('contract_type')" v-bind:class="{ 'active': contract_type }">契約種類</btn>
        <btn class="m-btn--column" @click.native="switchV('contract_date_start')" v-bind:class="{ 'active': contract_date_start }">契約日付</btn>
        <btn class="m-btn--column" @click.native="switchV('contract_date_end')" v-bind:class="{ 'active': contract_date_end }">~契約日付</btn>
        <btn class="m-btn--column" @click.native="switchV('change_date')" v-bind:class="{ 'active': change_date }">内容変更日付</btn>
        <btn class="m-btn--column" @click.native="switchV('cancel_type')" v-bind:class="{ 'active': cancel_type }">解約種類</btn>
        <btn class="m-btn--column" @click.native="switchV('cancel_date')" v-bind:class="{ 'active': cancel_date }">解約日付</btn>
        <btn class="m-btn--column" @click.native="switchV('f_name')" v-bind:class="{ 'active': f_name }">苗字</btn>
        <btn class="m-btn--column" @click.native="switchV('l_name')" v-bind:class="{ 'active': l_name }">名前</btn>
        <btn class="m-btn--column" @click.native="switchV('f_name_kana')" v-bind:class="{ 'active': f_name_kana }">苗字かな</btn>
        <btn class="m-btn--column" @click.native="switchV('l_name_kana')" v-bind:class="{ 'active': l_name_kana }">名前かな</btn>
        <btn class="m-btn--column" @click.native="switchV('tel')" v-bind:class="{ 'active': tel }">携帯TEL</btn>
        <btn class="m-btn--column" @click.native="switchV('tel2')" v-bind:class="{ 'active': tel2 }">固定TEL</btn>
        <btn class="m-btn--column" @click.native="switchV('address')" v-bind:class="{ 'active': address }">住所</btn>
        <btn class="m-btn--column" @click.native="switchV('address2')" v-bind:class="{ 'active': address2 }">住所2</btn>
        <btn class="m-btn--column" @click.native="switchV('person')" v-bind:class="{ 'active': person }">担当者</btn>
        <btn class="m-btn--column" @click.native="switchV('product_name')" v-bind:class="{ 'active': product_name }">商品名</btn>
        <btn class="m-btn--column" @click.native="switchV('payment_type')" v-bind:class="{ 'active': payment_type }">支払方法種別</btn>
        <btn class="m-btn--column" @click.native="switchV('text_type')" v-bind:class="{ 'active': text_type }">テキスト種類</btn>
        <btn class="m-btn--column" @click.native="switchV('amount')" v-bind:class="{ 'active': amount }">定価</btn>
        <btn class="m-btn--column" @click.native="switchV('discount')" v-bind:class="{ 'active': discount }">値引</btn>
        <btn class="m-btn--column" @click.native="switchV('pure_amount')" v-bind:class="{ 'active': pure_amount }">販売価格</btn>
        <btn class="m-btn--column" @click.native="switchV('division_commission')" v-bind:class="{ 'active': division_commission }">分割手数料</btn>
        <btn class="m-btn--column" @click.native="switchV('total_amount')" v-bind:class="{ 'active': total_amount }">お支払総額</btn>
        <btn class="m-btn--column" @click.native="switchV('payments_number')" v-bind:class="{ 'active': payments_number }">支払回数</btn>
        <btn class="m-btn--column" @click.native="switchV('deposit_amount_date')" v-bind:class="{ 'active': deposit_amount_date }">テキスト代入金日</btn>
        <btn class="m-btn--column" @click.native="switchV('text_payment_period_start')" v-bind:class="{ 'active': text_payment_period_start }">支払期間/開始(テキスト)</btn>
        <btn class="m-btn--column" @click.native="switchV('text_payment_period_end')" v-bind:class="{ 'active': text_payment_period_end }">支払期間/終了(テキスト)</btn>
        <btn class="m-btn--column" @click.native="switchV('service_period_start')" v-bind:class="{ 'active': service_period_start }">役務期間/開始</btn>
        <btn class="m-btn--column" @click.native="switchV('service_period_end')" v-bind:class="{ 'active': service_period_end }">役務期間/終了</btn>
        <btn class="m-btn--column" @click.native="switchV('first_month_deposit_method')" v-bind:class="{ 'active': first_month_deposit_method }">初月管理費支払方法</btn>
        <btn class="m-btn--column" @click.native="switchV('first_month_deposit_check')" v-bind:class="{ 'active': first_month_deposit_check }">初月管理費チェック</btn>
        <btn class="m-btn--column" @click.native="switchV('admission_fee')" v-bind:class="{ 'active': admission_fee }">入会金</btn>
        <btn class="m-btn--column" @click.native="switchV('admission_fee_method')" v-bind:class="{ 'active': admission_fee_method }">入会金支払方法</btn>
        <btn class="m-btn--column" @click.native="switchV('admission_fee_check')" v-bind:class="{ 'active': admission_fee_check }">入会金チェック</btn>
        <btn class="m-btn--column" @click.native="switchV('deposit')" v-bind:class="{ 'active': deposit }">保証金</btn>
        <btn class="m-btn--column" @click.native="switchV('deposit_method')" v-bind:class="{ 'active': deposit_method }">保証金支払方法</btn>
        <btn class="m-btn--column" @click.native="switchV('deposit_check')" v-bind:class="{ 'active': deposit_check }">保証金チェック</btn>
        <btn class="m-btn--column" @click.native="switchV('bank_number')" v-bind:class="{ 'active': bank_number }">銀行番号</btn>
        <btn class="m-btn--column" @click.native="switchV('branch_number')" v-bind:class="{ 'active': branch_number }">支店番号</btn>
        <btn class="m-btn--column" @click.native="switchV('deposit_item')" v-bind:class="{ 'active': deposit_item }">預金種目</btn>
        <btn class="m-btn--column" @click.native="switchV('account_number')" v-bind:class="{ 'active': account_number }">口座番号</btn>
        <btn class="m-btn--column" @click.native="switchV('account_holder')" v-bind:class="{ 'active': account_holder }">口座名義</btn>
        <btn class="m-btn--column" @click.native="switchV('expected_refund_date')" v-bind:class="{ 'active': expected_refund_date }">保証金返金予定日</btn>
        <btn class="m-btn--column" @click.native="switchV('deposit_refund_date')" v-bind:class="{ 'active': deposit_refund_date }">保証金返金日</btn>
        <btn class="m-btn--column" @click.native="switchV('approval_date')" v-bind:class="{ 'active': approval_date }">承認日</btn>
        <btn class="m-btn--column" @click.native="switchV('approval_number')" v-bind:class="{ 'active': approval_number }">承認No.</btn>
        <btn class="m-btn--column" @click.native="switchV('delivery_date')" v-bind:class="{ 'active': delivery_date }">納品日</btn>
        <btn class="m-btn--column" @click.native="switchV('contract_collection_date')" v-bind:class="{ 'active': contract_collection_date }">契約書回収日</btn>
        <btn class="m-btn--column" @click.native="switchV('factor_collection_date')" v-bind:class="{ 'active': factor_collection_date }">ファクター回収日</btn>
        <btn class="m-btn--column" @click.native="switchV('factor_check')" v-bind:class="{ 'active': factor_check }">ファクターチェック</btn>
        <btn class="m-btn--column" @click.native="switchV('ledger_check')" v-bind:class="{ 'active': ledger_check }">経理台帳入力</btn>
        <btn class="m-btn--column" @click.native="switchV('cancel_check')" v-bind:class="{ 'active': cancel_check }">CXLチェック</btn>
        <btn class="m-btn--column" @click.native="switchV('change_check')" v-bind:class="{ 'active': change_check }">内容変更チェック</btn>
        <btn class="m-btn--column" @click.native="switchV('grade')" v-bind:class="{ 'active': grade }">学年</btn>
        <btn class="m-btn--column" @click.native="switchV('point_total')" v-bind:class="{ 'active': point_total }">合計P</btn>
        <btn class="m-btn--column" @click.native="switchV('note')" v-bind:class="{ 'active': note }">備考</btn>
        <btn class="m-btn--column" @click.native="switchV('created_at')" v-bind:class="{ 'active': created_at }">作成日</btn>
        <btn class="m-btn--column" @click.native="switchV('updated_at')" v-bind:class="{ 'active': updated_at }">更新日</btn>
      </div>
    </template>

    <btn class="m-btn resetSearch" @click.native="resetSearch">Reset</btn>

    <div class="index-box" @scroll="offset">

      <table-c>
        <tr-c slot="tr-th">
          <template v-if="tag_id">
            <td-c class="select sticky-1">
              <multiselect v-model="watch.tag_id" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="id" :options="tags" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="payroll_check"><td-c class="sticky-1"><input v-model="search.payroll_check" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="id"><td-c class="sticky-1"><input v-model="search.id" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
          <template v-if="student_id"><td-c class="sticky-1"><input v-model="search.student_id" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="office_id">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.office_id" :options="offices" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="user_id">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.user_id" :options="users" label="user" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="contract_type">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.contract_type" :options="Contract_type" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="contract_date_start"><td-c class="sticky-1"><input v-model="search.contract_date[0]" type="text" @keyup="searchTable()" v-focus></td-c></template>
          <template v-if="contract_date_end"><td-c class="sticky-1"><input v-model="search.contract_date[1]" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="change_date"><td-c class="sticky-1"><input v-model="search.change_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="cancel_type">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.cancel_type" :options="Cancel_type" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="cancel_date"><td-c class="sticky-1"><input v-model="search.cancel_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="f_name"><td-c class="sticky-1"><input v-model="search.f_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="l_name"><td-c class="sticky-1"><input v-model="search.l_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="f_name_kana"><td-c class="sticky-1"><input v-model="search.f_name_kana" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="l_name_kana"><td-c class="sticky-1"><input v-model="search.l_name_kana" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="tel"><td-c class="sticky-1"><input v-model="search.tel" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="tel2"><td-c class="sticky-1"><input v-model="search.tel2" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="address"><td-c class="sticky-1"><input v-model="search.address" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="address2"><td-c class="sticky-1"><input v-model="search.address2" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="person"><td-c class="sticky-1"><input v-model="search.person" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="product_name"><td-c class="sticky-1"><input v-model="search.product_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="payment_type">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.payment_type" :options="Payment_type" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="text_type">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.text_type" :options="Text_type" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="amount"><td-c class="sticky-1"><input v-model="search.amount" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="discount"><td-c class="sticky-1"><input v-model="search.discount" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="pure_amount"><td-c class="sticky-1"><input v-model="search.pure_amount" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="division_commission"><td-c class="sticky-1"><input v-model="search.division_commission" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="total_amount"><td-c class="sticky-1"><input v-model="search.total_amount" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="payments_number">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.payments_number" :options="Payments_number" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="deposit_amount_date"><td-c class="sticky-1"><input v-model="search.deposit_amount_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="text_payment_period_start"><td-c class="sticky-1"><input v-model="search.text_payment_period_start" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="text_payment_period_end"><td-c class="sticky-1"><input v-model="search.text_payment_period_end" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="service_period_start"><td-c class="sticky-1"><input v-model="search.service_period_start" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="service_period_end"><td-c class="sticky-1"><input v-model="search.service_period_end" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="first_month_deposit_method">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.first_month_deposit_method" :options="Method" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="first_month_deposit_check"><td-c class="sticky-1"><input v-model="search.first_month_deposit_check" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="admission_fee"><td-c class="sticky-1"><input v-model="search.admission_fee" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="admission_fee_method">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.admission_fee_method" :options="Method" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="admission_fee_check"><td-c class="sticky-1"><input v-model="search.admission_fee_check" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="deposit"><td-c class="sticky-1"><input v-model="search.deposit" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="deposit_method">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.deposit_method" :options="Method" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="deposit_check"><td-c class="sticky-1"><input v-model="search.deposit_check" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="bank_number"><td-c class="sticky-1"><input v-model="search.bank_number" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="branch_number"><td-c class="sticky-1"><input v-model="search.branch_number" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="deposit_item">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.deposit_item" :options="Deposit_item" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="account_number"><td-c class="sticky-1"><input v-model="search.account_number" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="account_holder"><td-c class="sticky-1"><input v-model="search.account_holder" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="expected_refund_date"><td-c class="sticky-1"><input v-model="search.expected_refund_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="deposit_refund_date"><td-c class="sticky-1"><input v-model="search.deposit_refund_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="approval_date"><td-c class="sticky-1"><input v-model="search.approval_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="approval_number"><td-c class="sticky-1"><input v-model="search.approval_number" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="delivery_date"><td-c class="sticky-1"><input v-model="search.delivery_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="contract_collection_date"><td-c class="sticky-1"><input v-model="search.contract_collection_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="factor_collection_date"><td-c class="sticky-1"><input v-model="search.factor_collection_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="factor_check">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.factor_check" :options="Factor_check" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="ledger_check">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.ledger_check" :options="Ledger_check" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="cancel_check">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.cancel_check" :options="Cancel_check" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="change_check">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.change_check" :options="Change_check" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="grade"><td-c class="sticky-1"><input v-model="search.grade" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="point_total"><td-c class="sticky-1"><input v-model="search.point_total" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="note"><td-c class="sticky-1"><input v-model="search.note" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="created_at"><td-c class="sticky-1"><input v-model="search.created_at" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="updated_at"><td-c class="sticky-1"><input v-model="search.updated_at" type="text" @keyup="searchTable()"></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <template v-if="tag_id">
            <td-c class="select sticky-2">
              <multiselect v-model="watch.not_tag_id" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="id" :options="tags" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="payroll_check"><td-c class="sticky-2"><input v-model="search.not_payroll_check" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="id"><td-c class="sticky-2"><input v-model="search.not_id" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
          <template v-if="student_id"><td-c class="sticky-2"><input v-model="search.not_student_id" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="office_id">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_office_id" :options="offices" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="user_id">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_user_id" :options="users" label="user" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="contract_type">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_contract_type" :options="Contract_type" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="contract_date_start"><td-c class="sticky-2"><input v-model="search.not_contract_date[0]" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="contract_date_end"><td-c class="sticky-2"><input v-model="search.not_contract_date[1]" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="change_date"><td-c class="sticky-2"><input v-model="search.not_change_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="cancel_type">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_cancel_type" :options="Cancel_type" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="cancel_date"><td-c class="sticky-2"><input v-model="search.not_cancel_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="f_name"><td-c class="sticky-2"><input v-model="search.not_f_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="l_name"><td-c class="sticky-2"><input v-model="search.not_l_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="f_name_kana"><td-c class="sticky-2"><input v-model="search.not_f_name_kana" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="l_name_kana"><td-c class="sticky-2"><input v-model="search.not_l_name_kana" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="tel"><td-c class="sticky-2"><input v-model="search.not_tel" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="tel2"><td-c class="sticky-2"><input v-model="search.not_tel2" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="address"><td-c class="sticky-2"><input v-model="search.not_address" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="address2"><td-c class="sticky-2"><input v-model="search.not_address2" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="person"><td-c class="sticky-2"><input v-model="search.not_person" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="product_name"><td-c class="sticky-2"><input v-model="search.not_product_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="payment_type">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_payment_type" :options="Payment_type" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="text_type">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_text_type" :options="Text_type" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="amount"><td-c class="sticky-2"><input v-model="search.not_amount" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="discount"><td-c class="sticky-2"><input v-model="search.not_discount" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="pure_amount"><td-c class="sticky-2"><input v-model="search.not_pure_amount" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="division_commission"><td-c class="sticky-2"><input v-model="search.not_division_commission" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="total_amount"><td-c class="sticky-2"><input v-model="search.not_total_amount" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="payments_number">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_payments_number" :options="Payments_number" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="deposit_amount_date"><td-c class="sticky-2"><input v-model="search.not_deposit_amount_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="text_payment_period_start"><td-c class="sticky-2"><input v-model="search.not_text_payment_period_start" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="text_payment_period_end"><td-c class="sticky-2"><input v-model="search.not_text_payment_period_end" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="service_period_start"><td-c class="sticky-2"><input v-model="search.not_service_period_start" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="service_period_end"><td-c class="sticky-2"><input v-model="search.not_service_period_end" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="first_month_deposit_method">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_first_month_deposit_method" :options="Method" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="first_month_deposit_check"><td-c class="sticky-2"><input v-model="search.not_first_month_deposit_check" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="admission_fee"><td-c class="sticky-2"><input v-model="search.not_admission_fee" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="admission_fee_method">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_admission_fee_method" :options="Method" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="admission_fee_check"><td-c class="sticky-2"><input v-model="search.not_admission_fee_check" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="deposit"><td-c class="sticky-2"><input v-model="search.not_deposit" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="deposit_method">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_deposit_method" :options="Method" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="deposit_check"><td-c class="sticky-2"><input v-model="search.not_deposit_check" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="bank_number"><td-c class="sticky-2"><input v-model="search.not_bank_number" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="branch_number"><td-c class="sticky-2"><input v-model="search.not_branch_number" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="deposit_item">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_deposit_item" :options="Deposit_item" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="account_number"><td-c class="sticky-2"><input v-model="search.not_account_number" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="account_holder"><td-c class="sticky-2"><input v-model="search.not_account_holder" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="expected_refund_date"><td-c class="sticky-2"><input v-model="search.not_expected_refund_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="deposit_refund_date"><td-c class="sticky-2"><input v-model="search.not_deposit_refund_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="approval_date"><td-c class="sticky-2"><input v-model="search.not_approval_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="approval_number"><td-c class="sticky-2"><input v-model="search.not_approval_number" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="delivery_date"><td-c class="sticky-2"><input v-model="search.not_delivery_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="contract_collection_date"><td-c class="sticky-2"><input v-model="search.not_contract_collection_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="factor_collection_date"><td-c class="sticky-2"><input v-model="search.not_factor_collection_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="factor_check">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_factor_check" :options="Factor_check" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="ledger_check">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_ledger_check" :options="Ledger_check" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="cancel_check">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_cancel_check" :options="Cancel_check" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="change_check">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_change_check" :options="Change_check" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="grade"><td-c class="sticky-2"><input v-model="search.not_grade" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="point_total"><td-c class="sticky-2"><input v-model="search.not_point_total" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="note"><td-c class="sticky-2"><input v-model="search.not_note" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="created_at"><td-c class="sticky-2"><input v-model="search.not_created_at" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="updated_at"><td-c class="sticky-2"><input v-model="search.not_updated_at" type="text" @keyup="searchTable()"></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <template v-if="tag_id"><th-c class="sticky-3" @click.native='sort("tag_id")'>タグ</th-c></template>
          <template v-if="payroll_check"><th-c class="sticky-3" @click.native='sort("payroll_check")'>給与計算チェック</th-c></template>
          <template v-if="id"><th-c class="sticky-3" @click.native='sort("id")'>ID</th-c></template>
          <template v-if="student_id"><th-c class="sticky-3" @click.native='sort("student_id")'>生徒ID</th-c></template>
          <template v-if="office_id"><th-c class="sticky-3" @click.native='sort("office_id")'>営業所</th-c></template>
          <template v-if="user_id"><th-c class="sticky-3" @click.native='sort("user_id")'>登録者</th-c></template>
          <template v-if="contract_type"><th-c class="sticky-3" @click.native='sort("contract_type")'>契約種類</th-c></template>
          <template v-if="contract_date_start"><th-c class="sticky-3" @click.native='sort("contract_date")'>契約日付</th-c></template>
          <template v-if="contract_date_end"><th-c class="sticky-3" @click.native='sort("contract_date")'>〜契約日付</th-c></template>
          <template v-if="change_date"><th-c class="sticky-3" @click.native='sort("change_date")'>内容変更日付</th-c></template>
          <template v-if="cancel_type"><th-c class="sticky-3" @click.native='sort("cancel_type")'>解約種類</th-c></template>
          <template v-if="cancel_date"><th-c class="sticky-3" @click.native='sort("cancel_date")'>解約日付</th-c></template>
          <template v-if="f_name"><th-c class="sticky-3" @click.native='sort("f_name")'>苗字</th-c></template>
          <template v-if="l_name"><th-c class="sticky-3" @click.native='sort("l_name")'>名前</th-c></template>
          <template v-if="f_name_kana"><th-c class="sticky-3" @click.native='sort("f_name_kana")'>苗字かな</th-c></template>
          <template v-if="l_name_kana"><th-c class="sticky-3" @click.native='sort("l_name_kana")'>名前かな</th-c></template>
          <template v-if="tel"><th-c class="sticky-3" @click.native='sort("tel")'>携帯TEL</th-c></template>
          <template v-if="tel2"><th-c class="sticky-3" @click.native='sort("tel2")'>固定TEL</th-c></template>
          <template v-if="address"><th-c class="sticky-3" @click.native='sort("address")'>住所</th-c></template>
          <template v-if="address2"><th-c class="sticky-3" @click.native='sort("address2")'>住所2</th-c></template>
          <template v-if="person"><th-c class="sticky-3" @click.native='sort("person")'>担当者</th-c></template>
          <template v-if="product_name"><th-c class="sticky-3" @click.native='sort("product_name")'>商品名</th-c></template>
          <template v-if="payment_type"><th-c class="sticky-3" @click.native='sort("payment_type")'>支払方法種別</th-c></template>
          <template v-if="text_type"><th-c class="sticky-3" @click.native='sort("text_type")'>テキスト種類</th-c></template>
          <template v-if="amount"><th-c class="sticky-3" @click.native='sort("amount")'>定価</th-c></template>
          <template v-if="discount"><th-c class="sticky-3" @click.native='sort("discount")'>値引</th-c></template>
          <template v-if="pure_amount"><th-c class="sticky-3" @click.native='sort("pure_amount")'>販売価格 {{sum.pure_amount}}円</th-c></template>
          <template v-if="division_commission"><th-c class="sticky-3" @click.native='sort("division_commission")'>分割手数料 {{sum.division_commission}}円</th-c></template>
          <template v-if="total_amount"><th-c class="sticky-3" @click.native='sort("total_amount")'>お支払総額 {{sum.total_amount}}円</th-c></template>
          <template v-if="payments_number"><th-c class="sticky-3" @click.native='sort("payments_number")'>支払回数</th-c></template>
          <template v-if="deposit_amount_date"><th-c class="sticky-3" @click.native='sort("deposit_amount_date")'>テキスト代入金日</th-c></template>
          <template v-if="text_payment_period_start"><th-c class="sticky-3" @click.native='sort("text_payment_period_start")'>支払期間/開始(テキスト)</th-c></template>
          <template v-if="text_payment_period_end"><th-c class="sticky-3" @click.native='sort("text_payment_period_end")'>支払期間/終了(テキスト)</th-c></template>
          <template v-if="service_period_start"><th-c class="sticky-3" @click.native='sort("service_period_start")'>役務期間/開始</th-c></template>
          <template v-if="service_period_end"><th-c class="sticky-3" @click.native='sort("service_period_end")'>役務期間/終了</th-c></template>
          <template v-if="first_month_deposit_method"><th-c class="sticky-3" @click.native='sort("first_month_deposit_method")'>初月管理費支払方法</th-c></template>
          <template v-if="first_month_deposit_check"><th-c class="sticky-3" @click.native='sort("first_month_deposit_check")'>初月管理費チェック</th-c></template>
          <template v-if="admission_fee"><th-c class="sticky-3" @click.native='sort("admission_fee")'>入会金</th-c></template>
          <template v-if="admission_fee_method"><th-c class="sticky-3" @click.native='sort("admission_fee_method")'>入会金支払方法</th-c></template>
          <template v-if="admission_fee_check"><th-c class="sticky-3" @click.native='sort("admission_fee_check")'>入会金チェック</th-c></template>
          <template v-if="deposit"><th-c class="sticky-3" @click.native='sort("deposit")'>保証金</th-c></template>
          <template v-if="deposit_method"><th-c class="sticky-3" @click.native='sort("deposit_method")'>保証金支払方法</th-c></template>
          <template v-if="deposit_check"><th-c class="sticky-3" @click.native='sort("deposit_check")'>保証金チェック</th-c></template>
          <template v-if="bank_number"><th-c class="sticky-3" @click.native='sort("bank_number")'>銀行番号</th-c></template>
          <template v-if="branch_number"><th-c class="sticky-3" @click.native='sort("branch_number")'>支店番号</th-c></template>
          <template v-if="deposit_item"><th-c class="sticky-3" @click.native='sort("deposit_item")'>預金種目</th-c></template>
          <template v-if="account_number"><th-c class="sticky-3" @click.native='sort("account_number")'>口座番号</th-c></template>
          <template v-if="account_holder"><th-c class="sticky-3" @click.native='sort("account_holder")'>口座名義</th-c></template>
          <template v-if="expected_refund_date"><th-c class="sticky-3" @click.native='sort("expected_refund_date")'>保証金返金予定日</th-c></template>
          <template v-if="deposit_refund_date"><th-c class="sticky-3" @click.native='sort("deposit_refund_date")'>保証金返金日</th-c></template>
          <template v-if="approval_date"><th-c class="sticky-3" @click.native='sort("approval_date")'>承認日</th-c></template>
          <template v-if="approval_number"><th-c class="sticky-3" @click.native='sort("approval_number")'>承認No.</th-c></template>
          <template v-if="delivery_date"><th-c class="sticky-3" @click.native='sort("delivery_date")'>納品日</th-c></template>
          <template v-if="contract_collection_date"><th-c class="sticky-3" @click.native='sort("contract_collection_date")'>契約書回収日</th-c></template>
          <template v-if="factor_collection_date"><th-c class="sticky-3" @click.native='sort("factor_collection_date")'>ファクター回収日</th-c></template>
          <template v-if="factor_check"><th-c class="sticky-3" @click.native='sort("factor_check")'>ファクターチェック</th-c></template>
          <template v-if="ledger_check"><th-c class="sticky-3" @click.native='sort("ledger_check")'>経理台帳入力</th-c></template>
          <template v-if="cancel_check"><th-c class="sticky-3" @click.native='sort("cancel_check")'>CXLチェック</th-c></template>
          <template v-if="change_check"><th-c class="sticky-3" @click.native='sort("change_check")'>内容変更チェック</th-c></template>
          <template v-if="grade"><th-c class="sticky-3" @click.native='sort("grade")'>学年</th-c></template>
          <template v-if="point_total"><th-c class="sticky-3" @click.native='sort("point_total")'>合計P {{sum.point_total}}</th-c></template>
          <template v-if="note"><th-c class="sticky-3" @click.native='sort("note")'>備考</th-c></template>
          <template v-if="created_at"><th-c class="sticky-3" @click.native='sort("created_at")'>作成日</th-c></template>
          <template v-if="updated_at"><th-c class="sticky-3" @click.native='sort("updated_at")'>更新日</th-c></template>
        </tr-c>

        <tr-c @click.native='linkAgreement($event, list)' slot="tr-td" v-for="list in orderedAgreements" :key="list.id" class="tr_hover">
          <template v-if="tag_id">
            <template v-if="list.agreement_tags.length > 0">
              <td-c>
                <span
                  v-for="(list, index) in list.agreement_tags"
                  :key="index"
                  v-bind:style="{ 'backgroundColor': list.tag.color }"
                  style="color: #fff; padding: 5px; border-radius: 5px; margin: 2px; display: inline-block">
                  {{list.tag.name}}
                </span>
              </td-c>
            </template>
            <template v-else>
              <td-c></td-c>
            </template>
          </template>
          <template v-if="payroll_check"><td-c>{{list.payroll_check}}</td-c></template>
          <template v-if="id"><td-c>{{list.id}}</td-c></template>
          <template v-if="student_id"><td-c>{{list.student_id}}</td-c></template>
          <template v-if="office_id">
            <td-c v-if="list.office_id === 0"></td-c>
            <td-c v-if="list.office_id === 1">仙台</td-c>
            <td-c v-if="list.office_id === 2">札幌</td-c>
            <td-c v-if="list.office_id === 3">名古屋</td-c>
            <td-c v-if="list.office_id === 4">福岡</td-c>
            <td-c v-if="list.office_id === 5">新宿</td-c>
            <td-c v-if="list.office_id === 6">大宮</td-c>
            <td-c v-if="list.office_id === 7">高松</td-c>
            <td-c v-if="list.office_id === 8">高崎</td-c>
            <td-c v-if="list.office_id === 9">東京</td-c>
            <td-c v-if="list.office_id === 10">大阪</td-c>
          </template>
          <template v-if="user_id">
            <td-c v-if="list.user">{{list.user.user}}</td-c>
            <td-c v-else></td-c>
          </template>
          <template v-if="contract_type">
            <td-c
              v-bind:class="{
                blue: list.contract_type === '新規' && color,
                orange: list.contract_type === '引継' && color,
              }">{{ list.contract_type }}</td-c>
          </template>
          <template v-if="contract_date_start">
            <td-c v-if="list.contract_date">{{list.contract_date.substring(0, 10)}}</td-c>
            <td-c v-else>{{list.contract_date}}</td-c>
          </template>
          <template v-if="contract_date_end">
            <td-c></td-c>
          </template>
          <template v-if="change_date">
            <td-c v-if="list.change_date">{{list.change_date.substring(0, 10)}}</td-c>
            <td-c v-else>{{list.change_date}}</td-c>
          </template>
          <template v-if="cancel_type"><td-c>{{list.cancel_type}}</td-c></template>
          <template v-if="cancel_date">
            <td-c v-if="list.cancel_date">{{list.cancel_date.substring(0, 10)}}</td-c>
            <td-c v-else>{{list.cancel_date}}</td-c>
          </template>
          <template v-if="f_name"><td-c>{{list.f_name}}</td-c></template>
          <template v-if="l_name"><td-c>{{list.l_name}}</td-c></template>
          <template v-if="f_name_kana"><td-c>{{list.f_name_kana}}</td-c></template>
          <template v-if="l_name_kana"><td-c>{{list.l_name_kana}}</td-c></template>
          <template v-if="tel"><td-c>{{list.tel}}</td-c></template>
          <template v-if="tel2"><td-c>{{list.tel2}}</td-c></template>
          <template v-if="address"><td-c>{{list.address}}</td-c></template>
          <template v-if="address2"><td-c>{{list.address2}}</td-c></template>
          <template v-if="person"><td-c>{{list.person}}</td-c></template>
          <template v-if="product_name"><td-c>{{list.product_name}}</td-c></template>
          <template v-if="payment_type">
            <td-c
              v-bind:class="{
                green: list.payment_type === '一括' && color ||
                  list.payment_type === '一括(他社入金カード)' && color,
                purple: list.payment_type === '信販九州日本信販' && color ||
                  list.payment_type === '信販SP' && color ||
                  list.payment_type === '信販ニチクレ' && color ||
                  list.payment_type === '信販アスマイル' && color ||
                  list.payment_type === '信販ライフティ' && color ||
                  list.payment_type === '信販ダブルラック' && color,
                DarkBlue: list.payment_type === '自社割賦' && color,
                yellow: list.payment_type === 'のみ(旧料金 9800)' && color ||
                  list.payment_type === 'のみ(旧料金 12400)' && color ||
                  list.payment_type === 'のみ(未就学児 5000)' && color ||
                  list.payment_type === 'のみ(小学生 8000)' && color ||
                  list.payment_type === 'のみ(中1~中3.9月 11000)' && color ||
                  list.payment_type === 'のみ(中学受験 13000)' && color ||
                  list.payment_type === 'のみ(中3.10月~高校生 15000)' && color ||
                  list.payment_type === 'のみ(高校生 6000)' && color ||
                  list.payment_type === 'のみ(10000)' && color ||
                  list.payment_type === 'のみ(12500)' && color ||
                  list.payment_type === 'のみ(16700)' && color ||
                  list.payment_type === 'のみ(20000)' && color,
              }">{{ list.payment_type }}</td-c>
          </template>
          <template v-if="text_type"><td-c>{{list.text_type}}</td-c></template>
          <template v-if="amount"><td-c>{{list.amount}}</td-c></template>
          <template v-if="discount"><td-c>{{list.discount}}</td-c></template>
          <template v-if="pure_amount"><td-c>{{list.pure_amount}}</td-c></template>
          <template v-if="division_commission"><td-c>{{list.division_commission}}</td-c></template>
          <template v-if="total_amount"><td-c>{{list.total_amount}}</td-c></template>
          <template v-if="payments_number"><td-c>{{list.payments_number}}</td-c></template>
          <template v-if="deposit_amount_date"><td-c>{{list.deposit_amount_date}}</td-c></template>
          <template v-if="text_payment_period_start">
            <td-c v-if="list.text_payment_period_start">{{list.text_payment_period_start.substring(0, 10)}}</td-c>
            <td-c v-else>{{list.text_payment_period_start}}</td-c>
          </template>
          <template v-if="text_payment_period_end">
            <td-c v-if="list.text_payment_period_end">{{list.text_payment_period_end.substring(0, 10)}}</td-c>
            <td-c v-else>{{list.text_payment_period_end}}</td-c>
          </template>
          <template v-if="service_period_start">
            <td-c v-if="list.service_period_start">{{list.service_period_start.substring(0, 10)}}</td-c>
            <td-c v-else>{{list.service_period_start}}</td-c>
          </template>
          <template v-if="service_period_end">
            <td-c v-if="list.service_period_end">{{list.service_period_end.substring(0, 10)}}</td-c>
            <td-c v-else>{{list.service_period_end}}</td-c>
          </template>
          <template v-if="first_month_deposit_method"><td-c>{{list.first_month_deposit_method}}</td-c></template>
          <template v-if="first_month_deposit_check"><td-c>{{list.first_month_deposit_check}}</td-c></template>
          <template v-if="admission_fee"><td-c>{{list.admission_fee}}</td-c></template>
          <template v-if="admission_fee_method">
            <td-c v-if="list.admission_fee_method === 0"></td-c>
            <td-c v-if="list.admission_fee_method === 1">振込</td-c>
            <td-c v-if="list.admission_fee_method === 2">現金</td-c>
            <td-c v-if="list.admission_fee_method === 3">Coiney</td-c>
          </template>
          <template v-if="admission_fee_check"><td-c>{{list.admission_fee_check}}</td-c></template>
          <template v-if="deposit"><td-c>{{list.deposit}}</td-c></template>
          <template v-if="deposit_method">
            <td-c v-if="list.deposit_method === 0"></td-c>
            <td-c v-if="list.deposit_method === 1">振込</td-c>
            <td-c v-if="list.deposit_method === 2">現金</td-c>
            <td-c v-if="list.deposit_method === 3">Coiney</td-c>
          </template>
          <template v-if="deposit_check"><td-c>{{list.deposit_check}}</td-c></template>
          <template v-if="bank_number"><td-c>{{list.bank_number}}</td-c></template>
          <template v-if="branch_number"><td-c>{{list.branch_number}}</td-c></template>
          <template v-if="deposit_item">
            <td-c v-if="list.deposit_item === 0"></td-c>
            <td-c v-if="list.deposit_item === 1">普通</td-c>
            <td-c v-if="list.deposit_item === 2">当座</td-c>
          </template>
          <template v-if="account_number"><td-c>{{list.account_number}}</td-c></template>
          <template v-if="account_holder"><td-c>{{list.account_holder}}</td-c></template>
          <template v-if="expected_refund_date">
            <td-c v-if="list.expected_refund_date">{{list.expected_refund_date.substring(0, 10)}}</td-c>
            <td-c v-else>{{list.expected_refund_date}}</td-c>
          </template>
          <template v-if="deposit_refund_date">
            <td-c v-if="list.deposit_refund_date">{{list.deposit_refund_date.substring(0, 10)}}</td-c>
            <td-c v-else>{{list.deposit_refund_date}}</td-c>
          </template>
          <template v-if="approval_date">
            <td-c v-if="list.approval_date">{{list.approval_date.substring(0, 10)}}</td-c>
            <td-c v-else>{{list.approval_date}}</td-c>
          </template>
          <template v-if="approval_number"><td-c>{{list.approval_number}}</td-c></template>
          <template v-if="delivery_date">
            <td-c v-if="list.delivery_date">{{list.delivery_date.substring(0, 10)}}</td-c>
            <td-c v-else>{{list.delivery_date}}</td-c>
          </template>
          <template v-if="contract_collection_date">
            <td-c v-if="list.contract_collection_date">{{list.contract_collection_date.substring(0, 10)}}</td-c>
            <td-c v-else>{{list.contract_collection_date}}</td-c>
          </template>
          <template v-if="factor_collection_date">
            <td-c v-if="list.factor_collection_date">{{list.factor_collection_date.substring(0, 10)}}</td-c>
            <td-c v-else>{{list.factor_collection_date}}</td-c>
          </template>
          <template v-if="factor_check">
            <td-c v-if="list.factor_check === 0">未選択</td-c>
            <td-c v-if="list.factor_check === 1">済</td-c>
            <td-c v-if="list.factor_check === 2">未</td-c>
            <td-c v-if="list.factor_check === 3">無</td-c>
          </template>
          <template v-if="ledger_check">
            <td-c v-if="list.ledger_check === 0">未選択</td-c>
            <td-c v-if="list.ledger_check === 1">済</td-c>
            <td-c v-if="list.ledger_check === 2">未</td-c>
            <td-c v-if="list.ledger_check === 3">無</td-c>
          </template>
          <template v-if="cancel_check">
            <td-c v-if="list.cancel_check === 0">未選択</td-c>
            <td-c v-if="list.cancel_check === 1">済</td-c>
            <td-c v-if="list.cancel_check === 2">未</td-c>
            <td-c v-if="list.cancel_check === 3">無</td-c>
          </template>
          <template v-if="change_check">
            <td-c v-if="list.change_check === 0">未選択</td-c>
            <td-c v-if="list.change_check === 1">済</td-c>
            <td-c v-if="list.change_check === 2">未</td-c>
            <td-c v-if="list.change_check === 3">無</td-c>
          </template>
          <template v-if="grade"><td-c>{{list.grade}}</td-c></template>
          <template v-if="point_total"><td-c>{{list.point_total}}</td-c></template>
          <template v-if="note"><td-c>{{list.note}}</td-c></template>
          <template v-if="created_at">
            <td-c v-if="list.created_at">{{list.created_at.substring(0, 10)}}</td-c>
            <td-c v-else>{{list.created_at}}</td-c>
          </template>
          <template v-if="updated_at">
            <td-c v-if="list.updated_at">{{list.updated_at.substring(0, 10)}}</td-c>
            <td-c v-else>{{list.updated_at}}</td-c>
          </template>
        </tr-c>
      </table-c>
    </div>

  </div>
</template>

<script>
import { getAPIURL } from '@/store/getters.js'
import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/agreements/search?limit=' + config.LIMIT

var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  offset: config.LIMIT,
  max: config.LIMIT + 1,
  url: url,
  searchUrl: url,
  pageName: 'agreement',
  pageNames: 'agreements'
}

let _ = window._
export default {
  directives: {
    focus: {
      inserted (el, binding) {
        el.focus()
        // console.log(el)
        // console.log(binding)
      }
    }
  },
  data () {
    return {
      column: false,
      sortState: '降順',
      sortColumn: 'id',

      color: false,

      tag_id: true,
      payroll_check: true,
      id: false,
      student_id: false,
      office_id: true,
      user_id: false,
      contract_type: true,
      contract_date_start: true,
      contract_date_end: true,
      change_date: true,
      cancel_type: true,
      cancel_date: true,
      f_name: true,
      l_name: true,
      f_name_kana: true,
      l_name_kana: true,
      tel: true,
      tel2: true,
      address: true,
      address2: true,
      person: true,
      product_name: true,
      payment_type: true,
      text_type: true,
      amount: true,
      discount: true,
      pure_amount: true,
      division_commission: true,
      total_amount: true,
      payments_number: true,
      deposit_amount_date: true,
      text_payment_period_start: true,
      text_payment_period_end: true,
      service_period_start: true,
      service_period_end: true,
      first_month_deposit_method: true,
      first_month_deposit_check: true,
      admission_fee: true,
      admission_fee_method: true,
      admission_fee_check: true,
      deposit: true,
      deposit_method: true,
      deposit_check: true,
      bank_number: true,
      branch_number: true,
      deposit_item: true,
      account_number: true,
      account_holder: true,
      expected_refund_date: true,
      deposit_refund_date: true,
      approval_date: true,
      approval_number: true,
      delivery_date: true,
      contract_collection_date: true,
      factor_collection_date: true,
      factor_check: true,
      ledger_check: true,
      cancel_check: true,
      change_check: true,
      grade: true,
      point_total: true,
      note: true,
      created_at: true,
      updated_at: true,

      search: {
        tag_id: '',
        payroll_check: '',
        id: '',
        student_id: '',
        office_id: '',
        user_id: '',
        contract_type: '',
        contract_date: [],
        change_date: '',
        cancel_type: '',
        cancel_date: '',
        f_name: '',
        l_name: '',
        f_name_kana: '',
        l_name_kana: '',
        tel: '',
        tel2: '',
        address: '',
        address2: '',
        person: '',
        product_name: '',
        payment_type: '',
        text_type: '',
        amount: '',
        discount: '',
        pure_amount: '',
        division_commission: '',
        total_amount: '',
        payments_number: '',
        deposit_amount_date: '',
        text_payment_period_start: '',
        text_payment_period_end: '',
        service_period_start: '',
        service_period_end: '',
        first_month_deposit_method: '',
        first_month_deposit_check: '',
        admission_fee: '',
        admission_fee_method: '',
        admission_fee_check: '',
        deposit: '',
        deposit_method: '',
        deposit_check: '',
        bank_number: '',
        branch_number: '',
        deposit_item: '',
        account_number: '',
        account_holder: '',
        expected_refund_date: '',
        deposit_refund_date: '',
        approval_date: '',
        approval_number: '',
        delivery_date: '',
        contract_collection_date: '',
        factor_collection_date: '',
        factor_check: '',
        ledger_check: '',
        cancel_check: '',
        change_check: '',
        grade: '',
        point_total: '',
        note: '',
        created_at: '',
        updated_at: '',

        not_tag_id: '',
        not_payroll_check: '',
        not_id: '',
        not_student_id: '',
        not_office_id: '',
        not_user_id: '',
        not_contract_type: '',
        not_contract_date: [],
        not_change_date: '',
        not_cancel_type: '',
        not_cancel_date: '',
        not_f_name: '',
        not_l_name: '',
        not_f_name_kana: '',
        not_l_name_kana: '',
        not_tel: '',
        not_tel2: '',
        not_address: '',
        not_address2: '',
        not_deposit_amount_date: '',
        not_person: '',
        not_product_name: '',
        not_payment_type: '',
        not_text_type: '',
        not_amount: '',
        not_discount: '',
        not_pure_amount: '',
        not_division_commission: '',
        not_total_amount: '',
        not_payments_number: '',
        not_text_payment_period_start: '',
        not_text_payment_period_end: '',
        not_service_period_start: '',
        not_service_period_end: '',
        not_first_month_deposit_method: '',
        not_first_month_deposit_check: '',
        not_admission_fee: '',
        not_admission_fee_method: '',
        not_admission_fee_check: '',
        not_deposit: '',
        not_deposit_method: '',
        not_deposit_check: '',
        not_bank_number: '',
        not_branch_number: '',
        not_deposit_item: '',
        not_account_number: '',
        not_account_holder: '',
        not_expected_refund_date: '',
        not_deposit_refund_date: '',
        not_approval_date: '',
        not_approval_number: '',
        not_delivery_date: '',
        not_contract_collection_date: '',
        not_factor_collection_date: '',
        not_factor_check: '',
        not_ledger_check: '',
        not_cancel_check: '',
        not_change_check: '',
        not_grade: '',
        not_point_total: '',
        not_note: '',
        not_created_at: '',
        not_updated_at: ''
      },

      watch: {
        tag_id: [],
        office_id: '',
        user_id: '',
        contract_type: '',
        cancel_type: '',
        payment_type: '',
        text_type: '',
        payments_number: '',
        first_month_deposit_method: '',
        admission_fee_method: '',
        deposit_method: '',
        deposit_item: '',
        factor_check: '',
        ledger_check: '',
        cancel_check: '',
        change_check: '',

        not_tag_id: [],
        not_office_id: '',
        not_user_id: '',
        not_contract_type: '',
        not_cancel_type: '',
        not_payment_type: '',
        not_text_type: '',
        not_payments_number: '',
        not_first_month_deposit_method: '',
        not_admission_fee_method: '',
        not_deposit: '',
        not_deposit_method: '',
        not_deposit_item: '',
        not_factor_check: '',
        not_ledger_check: '',
        not_cancel_check: '',
        not_change_check: ''
      }
    }
  },
  computed: {
    obj () {
      return obj
    },

    max () {
      return this.$store.getters.max
    },

    sum () {
      return this.$store.getters.sum
    },

    Contract_type () {
      return this.$store.getters['agreements/contract_type']
    },

    Cancel_type () {
      return this.$store.getters['agreements/cancel_type']
    },

    Payment_type () {
      return this.$store.getters['agreements/payment_type']
    },

    Text_type () {
      return this.$store.getters['agreements/text_type']
    },

    Payments_number () {
      return this.$store.getters['agreements/payments_number']
    },

    Method () {
      return this.$store.getters['agreements/method']
    },

    Deposit_item () {
      return this.$store.getters['agreements/deposit_item']
    },

    Factor_check () {
      return this.$store.getters['agreements/factor_check']
    },

    Ledger_check () {
      return this.$store.getters['agreements/ledger_check']
    },

    Cancel_check () {
      return this.$store.getters['agreements/cancel_check']
    },

    Change_check () {
      return this.$store.getters['agreements/change_check']
    },

    tags () {
      return this.$store.getters.tags
    },

    offices () {
      return this.$store.getters.offices
    },

    digestibility () {
      return this.$store.getters.digestibility
    },

    agreements () {
      return this.$store.getters.agreements
    },

    users () {
      return this.$store.getters.users
    },

    user () {
      return this.$store.getters.user
    },

    orderedAgreements () {
      if (this.sortState === '' || this.sortState === '降順') {
        return _.orderBy(this.agreements, this.sortColumn).reverse()
      } else if (this.sortState === '昇順') {
        return _.orderBy(this.agreements, this.sortColumn)
      }
    }
  },
  watch: {
    'watch.tag_id': function (now, old) {
      if (now) {
        this.search.tag_id = ''
        for (let i = 0; i < now.length; i++) {
          this.search.tag_id += now[i].id + ' '
        }
        this.searchTable()
      }
    },

    'watch.not_tag_id': function (now, old) {
      if (now) {
        this.search.not_tag_id = ''
        for (let i = 0; i < now.length; i++) {
          this.search.not_tag_id += now[i].id + ' '
        }
        this.searchTable()
      }
    },

    'watch.office_id': function (now, old) {
      if (now) {
        this.search.office_id = now.id
      } else {
        this.search.office_id = ''
      }
    },

    'watch.not_office_id': function (now, old) {
      if (now) {
        this.search.not_office_id = now.id
      } else {
        this.search.not_office_id = ''
      }
    },

    'watch.user_id': function (now, old) {
      if (now) {
        this.search.user_id = now.id
      } else {
        this.search.user_id = ''
      }
    },

    'watch.not_user_id': function (now, old) {
      if (now) {
        this.search.not_user_id = now.id
      } else {
        this.search.not_user_id = ''
      }
    },

    'watch.contract_type': function (now, old) {
      if (now) {
        this.search.contract_type = now.value
      } else {
        this.search.contract_type = ''
      }
    },

    'watch.not_contract_type': function (now, old) {
      if (now) {
        this.search.not_contract_type = now.value
      } else {
        this.search.not_contract_type = ''
      }
    },

    'watch.cancel_type': function (now, old) {
      if (now) {
        this.search.cancel_type = now.value
      } else {
        this.search.cancel_type = ''
      }
    },

    'watch.not_cancel_type': function (now, old) {
      if (now) {
        this.search.not_cancel_type = now.value
      } else {
        this.search.not_cancel_type = ''
      }
    },

    'watch.payment_type': function (now, old) {
      if (now) {
        this.search.payment_type = now.value
      } else {
        this.search.payment_type = ''
      }
    },

    'watch.not_payment_type': function (now, old) {
      if (now) {
        this.search.not_payment_type = now.value
      } else {
        this.search.not_payment_type = ''
      }
    },

    'watch.text_type': function (now, old) {
      if (now) {
        this.search.text_type = now.value
      } else {
        this.search.text_type = ''
      }
    },

    'watch.not_text_type': function (now, old) {
      if (now) {
        this.search.not_text_type = now.value
      } else {
        this.search.not_text_type = ''
      }
    },

    'watch.payments_number': function (now, old) {
      if (now) {
        this.search.payments_number = now.value
      } else {
        this.search.payments_number = ''
      }
    },

    'watch.not_payments_number': function (now, old) {
      if (now) {
        this.search.not_payments_number = now.value
      } else {
        this.search.not_payments_number = ''
      }
    },

    'watch.first_month_deposit_method': function (now, old) {
      if (now) {
        this.search.first_month_deposit_method = now.value
      } else {
        this.search.first_month_deposit_method = ''
      }
    },

    'watch.not_first_month_deposit_method': function (now, old) {
      if (now) {
        this.search.not_first_month_deposit_method = now.value
      } else {
        this.search.not_first_month_deposit_method = ''
      }
    },

    'watch.admission_fee_method': function (now, old) {
      if (now) {
        this.search.admission_fee_method = now.value
      } else {
        this.search.admission_fee_method = ''
      }
    },

    'watch.not_admission_fee_method': function (now, old) {
      if (now) {
        this.search.not_admission_fee_method = now.value
      } else {
        this.search.not_admission_fee_method = ''
      }
    },

    'watch.deposit_method': function (now, old) {
      if (now) {
        this.search.deposit_method = now.value
      } else {
        this.search.deposit_method = ''
      }
    },

    'watch.not_deposit_method': function (now, old) {
      if (now) {
        this.search.not_deposit_method = now.value
      } else {
        this.search.not_deposit_method = ''
      }
    },

    'watch.deposit_item': function (now, old) {
      if (now) {
        this.search.deposit_item = now.value
      } else {
        this.search.deposit_item = ''
      }
    },

    'watch.not_deposit_item': function (now, old) {
      if (now) {
        this.search.not_deposit_item = now.value
      } else {
        this.search.not_deposit_item = ''
      }
    },

    'watch.factor_check': function (now, old) {
      if (now) {
        this.search.factor_check = now.value
      } else {
        this.search.factor_check = ''
      }
    },

    'watch.not_factor_check': function (now, old) {
      if (now) {
        this.search.not_factor_check = now.value
      } else {
        this.search.not_factor_check = ''
      }
    },

    'watch.ledger_check': function (now, old) {
      if (now) {
        this.search.ledger_check = now.value
      } else {
        this.search.ledger_check = ''
      }
    },

    'watch.not_ledger_check': function (now, old) {
      if (now) {
        this.search.not_ledger_check = now.value
      } else {
        this.search.not_ledger_check = ''
      }
    },

    'watch.cancel_check': function (now, old) {
      if (now) {
        this.search.cancel_check = now.value
      } else {
        this.search.cancel_check = ''
      }
    },

    'watch.not_cancel_check': function (now, old) {
      if (now) {
        this.search.not_cancel_check = now.value
      } else {
        this.search.not_cancel_check = ''
      }
    },

    'watch.change_check': function (now, old) {
      if (now) {
        this.search.change_check = now.value
      } else {
        this.search.change_check = ''
      }
    },

    'watch.not_change_check': function (now, old) {
      if (now) {
        this.search.not_change_check = now.value
      } else {
        this.search.not_change_check = ''
      }
    }
  },
  methods: {
    switchV (col) {
      this[col] = !this[col]
    },

    select (selectedOption, id) {
      // console.log(selectedOption)
    },

    reset () {
      this.color = false

      this.tag_id = false
      this.payroll_check = false
      this.id = false
      this.student_id = false
      this.office_id = false
      this.user_id = false
      this.contract_type = false
      this.contract_date_start = false
      this.contract_date_end = false
      this.change_date = false
      this.cancel_type = false
      this.cancel_date = false
      this.f_name = false
      this.l_name = false
      this.f_name_kana = false
      this.l_name_kana = false
      this.tel = false
      this.tel2 = false
      this.address = false
      this.address2 = false
      this.amount = false
      this.discount = false
      this.split_commission = false
      this.sales_commission = false
      this.sales_commission_head = false
      this.sales_commission_branch = false
      this.old_amount = false
      this.agency_commission = false
      this.agency_commission_head = false
      this.agency_commission_branch = false
      this.purchase_amount = false
      this.purchase_amount_head = false
      this.purchase_amount_branch = false
      this.only_total_amount = false
      this.only_total_amount_head = false
      this.only_total_amount_branch = false
      this.down_payment = false
      this.deposit_amount = false
      this.person = false
      this.product_name = false
      this.payment_type = false
      this.text_type = false
      this.amount = false
      this.discount = false
      this.pure_amount = false
      this.division_commission = false
      this.total_amount = false
      this.payments_number = false
      this.deposit_amount_date = false
      this.text_payment_period_start = false
      this.text_payment_period_end = false
      this.service_period_start = false
      this.service_period_end = false
      this.administrative_expense = false
      this.first_month_deposit = false
      this.first_month_deposit_method = false
      this.first_month_deposit_check = false
      this.admission_fee = false
      this.admission_fee_method = false
      this.admission_fee_check = false
      this.deposit = false
      this.deposit_method = false
      this.deposit_check = false
      this.bank_number = false
      this.branch_number = false
      this.deposit_item = false
      this.account_number = false
      this.account_holder = false
      this.expected_refund_date = false
      this.deposit_refund_date = false
      this.approval_date = false
      this.approval_number = false
      this.delivery_date = false
      this.contract_collection_date = false
      this.factor_collection_date = false
      this.factor_check = false
      this.ledger_check = false
      this.cancel_check = false
      this.change_check = false
      this.grade = false
      this.point_s = false
      this.point_c = false
      this.point_k = false
      this.point_s_bulk = false
      this.point_c_bulk = false
      this.point_k_bulk = false
      this.point_total = false
      this.note = false
      this.created_at = false
      this.updated_at = false
    },

    all () {
      this.color = false

      this.tag_id = true
      this.payroll_check = true
      this.id = true
      this.student_id = true
      this.office_id = true
      this.user_id = true
      this.contract_type = true
      this.contract_date_start = true
      this.contract_date_end = true
      this.change_date = true
      this.cancel_type = true
      this.cancel_date = true
      this.f_name = true
      this.l_name = true
      this.f_name_kana = true
      this.l_name_kana = true
      this.tel = true
      this.tel2 = true
      this.address = true
      this.address2 = true
      this.amount = true
      this.discount = true
      this.split_commission = true
      this.sales_commission = true
      this.sales_commission_head = true
      this.sales_commission_branch = true
      this.old_amount = true
      this.agency_commission = true
      this.agency_commission_head = true
      this.agency_commission_branch = true
      this.purchase_amount = true
      this.purchase_amount_head = true
      this.purchase_amount_branch = true
      this.only_total_amount = true
      this.only_total_amount_head = true
      this.only_total_amount_branch = true
      this.down_payment = true
      this.deposit_amount = true
      this.person = true
      this.product_name = true
      this.payment_type = true
      this.text_type = true
      this.amount = true
      this.discount = true
      this.pure_amount = true
      this.division_commission = true
      this.total_amount = true
      this.payments_number = true
      this.deposit_amount_date = true
      this.text_payment_period_start = true
      this.text_payment_period_end = true
      this.service_period_start = true
      this.service_period_end = true
      this.administrative_expense = true
      this.first_month_deposit = true
      this.first_month_deposit_method = true
      this.first_month_deposit_check = true
      this.admission_fee = true
      this.admission_fee_method = true
      this.admission_fee_check = true
      this.deposit = true
      this.deposit_method = true
      this.deposit_check = true
      this.bank_number = true
      this.branch_number = true
      this.deposit_item = true
      this.account_number = true
      this.account_holder = true
      this.expected_refund_date = true
      this.deposit_refund_date = true
      this.approval_date = true
      this.approval_number = true
      this.delivery_date = true
      this.contract_collection_date = true
      this.factor_collection_date = true
      this.factor_check = true
      this.ledger_check = true
      this.cancel_check = true
      this.change_check = true
      this.grade = true
      this.point_s = true
      this.point_c = true
      this.point_k = true
      this.point_s_bulk = true
      this.point_c_bulk = true
      this.point_k_bulk = true
      this.point_total = true
      this.note = true
      this.created_at = true
      this.updated_at = true
    },

    def () {
      this.color = false

      this.tag_id = true
      this.payroll_check = true
      this.id = false
      this.student_id = false
      this.office_id = true
      this.user_id = false
      this.contract_type = true
      this.contract_date_start = true
      this.contract_date_end = true
      this.change_date = true
      this.cancel_type = true
      this.cancel_date = true
      this.f_name = true
      this.l_name = true
      this.f_name_kana = true
      this.l_name_kana = true
      this.tel = true
      this.tel2 = true
      this.address = true
      this.address2 = true
      this.amount = true
      this.discount = true
      this.split_commission = true
      this.sales_commission = true
      this.sales_commission_head = true
      this.sales_commission_branch = true
      this.old_amount = true
      this.agency_commission = true
      this.agency_commission_head = true
      this.agency_commission_branch = true
      this.purchase_amount = true
      this.purchase_amount_head = true
      this.purchase_amount_branch = true
      this.only_total_amount = true
      this.only_total_amount_head = true
      this.only_total_amount_branch = true
      this.down_payment = true
      this.deposit_amount = true
      this.person = true
      this.product_name = true
      this.payment_type = true
      this.text_type = true
      this.amount = true
      this.discount = true
      this.pure_amount = true
      this.division_commission = true
      this.total_amount = true
      this.payments_number = true
      this.deposit_amount_date = true
      this.text_payment_period_start = true
      this.text_payment_period_end = true
      this.service_period_start = true
      this.service_period_end = true
      this.administrative_expense = true
      this.first_month_deposit = true
      this.first_month_deposit_method = true
      this.first_month_deposit_check = true
      this.admission_fee = true
      this.admission_fee_method = true
      this.admission_fee_check = true
      this.deposit = true
      this.deposit_method = true
      this.deposit_check = true
      this.bank_number = true
      this.branch_number = true
      this.deposit_item = true
      this.account_number = true
      this.account_holder = true
      this.expected_refund_date = true
      this.deposit_refund_date = true
      this.approval_date = true
      this.approval_number = true
      this.delivery_date = true
      this.contract_collection_date = true
      this.factor_collection_date = true
      this.factor_check = true
      this.ledger_check = true
      this.cancel_check = true
      this.change_check = true
      this.grade = true
      this.point_s = true
      this.point_c = true
      this.point_k = true
      this.point_s_bulk = true
      this.point_c_bulk = true
      this.point_k_bulk = true
      this.point_total = true
      this.note = true
      this.created_at = true
      this.updated_at = true
    },

    ad () {
      this.color = true

      this.tag_id = true
      this.payroll_check = true
      this.id = false
      this.student_id = false
      this.office_id = false
      this.user_id = false
      this.contract_type = true
      this.contract_date_start = true
      this.contract_date_end = true
      this.change_date = false
      this.cancel_type = true
      this.cancel_date = false
      this.f_name = true
      this.l_name = true
      this.f_name_kana = false
      this.l_name_kana = false
      this.tel = false
      this.tel2 = false
      this.address = true
      this.address2 = true
      this.amount = false
      this.discount = false
      this.split_commission = false
      this.sales_commission = false
      this.sales_commission_head = false
      this.sales_commission_branch = false
      this.old_amount = false
      this.agency_commission = false
      this.agency_commission_head = false
      this.agency_commission_branch = false
      this.purchase_amount = false
      this.purchase_amount_head = false
      this.purchase_amount_branch = false
      this.only_total_amount = false
      this.only_total_amount_head = false
      this.only_total_amount_branch = false
      this.down_payment = false
      this.deposit_amount = false
      this.person = true
      this.product_name = false
      this.payment_type = true
      this.text_type = false
      this.amount = false
      this.discount = false
      this.pure_amount = true
      this.division_commission = false
      this.total_amount = false
      this.payments_number = true
      this.deposit_amount_date = false
      this.text_payment_period_start = false
      this.text_payment_period_end = false
      this.service_period_start = false
      this.service_period_end = false
      this.administrative_expense = false
      this.first_month_deposit = false
      this.first_month_deposit_method = false
      this.first_month_deposit_check = true
      this.admission_fee = true
      this.admission_fee_method = true
      this.admission_fee_check = true
      this.deposit = false
      this.deposit_method = false
      this.deposit_check = false
      this.bank_number = false
      this.branch_number = false
      this.deposit_item = false
      this.account_number = false
      this.account_holder = false
      this.expected_refund_date = false
      this.deposit_refund_date = false
      this.approval_date = true
      this.approval_number = false
      this.delivery_date = false
      this.contract_collection_date = false
      this.factor_collection_date = false
      this.factor_check = false
      this.ledger_check = false
      this.cancel_check = false
      this.change_check = false
      this.grade = false
      this.point_s = false
      this.point_c = false
      this.point_k = false
      this.point_s_bulk = false
      this.point_c_bulk = false
      this.point_k_bulk = false
      this.point_total = true
      this.note = false
      this.created_at = false
      this.updated_at = false
    },

    ledger () {
      this.color = false

      this.tag_id = true
      this.payroll_check = false
      this.id = false
      this.student_id = false
      this.office_id = false
      this.user_id = false
      this.contract_type = true
      this.contract_date_start = true
      this.contract_date_end = false
      this.change_date = true
      this.cancel_type = true
      this.cancel_date = false
      this.f_name = true
      this.l_name = true
      this.f_name_kana = false
      this.l_name_kana = false
      this.tel = true
      this.tel2 = false
      this.address = false
      this.address2 = false
      this.amount = false
      this.discount = false
      this.split_commission = false
      this.sales_commission = false
      this.sales_commission_head = false
      this.sales_commission_branch = false
      this.old_amount = false
      this.agency_commission = false
      this.agency_commission_head = false
      this.agency_commission_branch = false
      this.purchase_amount = false
      this.purchase_amount_head = false
      this.purchase_amount_branch = false
      this.only_total_amount = false
      this.only_total_amount_head = false
      this.only_total_amount_branch = false
      this.down_payment = false
      this.deposit_amount = false
      this.person = false
      this.product_name = false
      this.payment_type = true
      this.text_type = false
      this.amount = false
      this.discount = false
      this.pure_amount = true
      this.division_commission = true
      this.total_amount = true
      this.payments_number = true
      this.deposit_amount_date = false
      this.text_payment_period_start = false
      this.text_payment_period_end = false
      this.service_period_start = false
      this.service_period_end = false
      this.administrative_expense = false
      this.first_month_deposit = false
      this.first_month_deposit_method = false
      this.first_month_deposit_check = false
      this.admission_fee = false
      this.admission_fee_method = false
      this.admission_fee_check = false
      this.deposit = false
      this.deposit_method = false
      this.deposit_check = false
      this.bank_number = false
      this.branch_number = false
      this.deposit_item = false
      this.account_number = false
      this.account_holder = false
      this.expected_refund_date = false
      this.deposit_refund_date = false
      this.approval_date = false
      this.approval_number = false
      this.delivery_date = false
      this.contract_collection_date = false
      this.factor_collection_date = false
      this.factor_check = true
      this.ledger_check = true
      this.cancel_check = true
      this.change_check = true
      this.grade = false
      this.point_s = false
      this.point_c = false
      this.point_k = false
      this.point_s_bulk = false
      this.point_c_bulk = false
      this.point_k_bulk = false
      this.point_total = false
      this.note = false
      this.created_at = false
      this.updated_at = false
    },

    linkAgreement (event, agreement) {
      if (event.metaKey || event.ctrlKey) {
        let routeData = this.$router.resolve({name: 'agreementindex', params: { id: agreement.id }}); window.open(routeData.href, '_blank')
      } else {
        this.$router.push({name: 'agreementindex', params: { id: agreement.id }})
      }
    },

    sort (header) {
      if (this.sortState === '' || this.sortState === '降順') {
        this.sortState = '昇順'
        this.sortColumn = header
      } else if (this.sortState === '昇順') {
        this.sortState = '降順'
        this.sortColumn = header
      }
    },

    offset (e) {
      this.$store.dispatch('SCROLL', {
        this: this,
        e: e,
        obj: obj
      })
    },

    searchTable (e) {
      this.$store.dispatch('SEARCH', {
        this: this,
        e: e,
        obj: obj
      })
    },

    resetSearch () {
      this.search.id = ''
      this.search.student_id = ''
      this.watch.tag_id = []
      this.search.payroll_check = ''
      this.watch.office_id = 0
      this.watch.contract_type = 0
      this.search.contract_date = []
      this.search.change_date = ''
      this.watch.cancel_type = 0
      this.search.cancel_date = ''
      this.search.f_name = ''
      this.search.l_name = ''
      this.search.f_name_kana = ''
      this.search.l_name_kana = ''
      this.search.tel = ''
      this.search.tel2 = ''
      this.search.address = ''
      this.search.address2 = ''
      this.search.birthday = ''
      this.search.hourly_pay = ''
      this.search.amount = ''
      this.search.discount = ''
      this.search.split_commission = ''
      this.search.sales_commission = ''
      this.search.sales_commission_head = ''
      this.search.sales_commission_branch = ''
      this.search.old_amount = ''
      this.search.agency_commission = ''
      this.search.agency_commission_head = ''
      this.search.agency_commission_branch = ''
      this.search.purchase_amount = ''
      this.search.purchase_amount_head = ''
      this.search.purchase_amount_branch = ''
      this.search.only_total_amount = ''
      this.search.only_total_amount_head = ''
      this.search.only_total_amount_branch = ''
      this.search.down_payment = ''
      this.search.deposit_amount = ''
      this.search.person = ''
      this.search.product_name = ''
      this.watch.payment_type = 0
      this.watch.payments_number = 0
      this.search.deposit_amount_date = ''
      this.watch.text_type = 0
      this.search.amount = ''
      this.search.discount = ''
      this.search.pure_amount = ''
      this.search.division_commission = ''
      this.search.total_amount = ''
      this.search.text_grade_number = ''
      this.search.text_payment_period_start = ''
      this.search.text_payment_period_end = ''
      this.search.service_period_start = ''
      this.search.service_period_end = ''
      this.search.administrative_expense = ''
      this.search.first_month_deposit = ''
      this.watch.first_month_deposit_method = 0
      this.search.first_month_deposit_check = ''
      this.search.admission_fee = ''
      this.watch.admission_fee_method = 0
      this.search.admission_fee_check = ''
      this.search.deposit = ''
      this.watch.deposit_method = 0
      this.search.deposit_check = ''
      this.search.bank_number = ''
      this.search.branch_number = ''
      this.watch.deposit_item = 0
      this.search.account_number = ''
      this.search.account_holder = ''
      this.search.expected_refund_date = ''
      this.search.deposit_refund_date = ''
      this.search.approval_date = ''
      this.search.approval_number = ''
      this.search.delivery_date = ''
      this.search.contract_collection_date = ''
      this.search.factor_collection_date = ''
      this.watch.factor_check = 0
      this.watch.ledger_check = 0
      this.watch.cancel_check = 0
      this.watch.change_check = 0
      this.search.grade = ''
      this.search.point_s = ''
      this.search.point_c = ''
      this.search.point_k = ''
      this.search.point_s_bulk = ''
      this.search.point_c_bulk = ''
      this.search.point_k_bulk = ''
      this.search.point_total = ''
      this.search.note = ''

      this.search.not_id = ''
      this.search.not_student_id = ''
      this.watch.not_tag_id = []
      this.search.not_payroll_check = ''
      this.watch.not_office_id = 0
      this.watch.not_contract_type = 0
      this.search.not_contract_date = []
      this.search.not_change_date = ''
      this.watch.not_cancel_type = 0
      this.search.not_cancel_date = ''
      this.search.not_f_name = ''
      this.search.not_l_name = ''
      this.search.not_f_name_kana = ''
      this.search.not_l_name_kana = ''
      this.search.not_tel = ''
      this.search.not_tel2 = ''
      this.search.not_address = ''
      this.search.not_address2 = ''
      this.search.not_birthday = ''
      this.search.not_hourly_pay = ''
      this.search.not_amount = ''
      this.search.not_discount = ''
      this.search.not_split_commission = ''
      this.search.not_sales_commission = ''
      this.search.not_sales_commission_head = ''
      this.search.not_sales_commission_branch = ''
      this.search.not_old_amount = ''
      this.search.not_agency_commission = ''
      this.search.not_agency_commission_head = ''
      this.search.not_agency_commission_branch = ''
      this.search.not_purchase_amount = ''
      this.search.not_purchase_amount_head = ''
      this.search.not_purchase_amount_branch = ''
      this.search.not_only_total_amount = ''
      this.search.not_only_total_amount_head = ''
      this.search.not_only_total_amount_branch = ''
      this.search.not_down_payment = ''
      this.search.not_deposit_amount = ''
      this.search.not_deposit_amount_date = ''
      this.search.not_person = ''
      this.search.not_product_name = ''
      this.watch.not_payment_type = 0
      this.watch.not_payments_number = 0
      this.watch.not_text_type = 0
      this.search.not_amount = ''
      this.search.not_discount = ''
      this.search.not_pure_amount = ''
      this.search.not_division_commission = ''
      this.search.not_total_amount = ''
      this.search.not_text_grade_number = ''
      this.search.not_text_payment_period_start = ''
      this.search.not_text_payment_period_end = ''
      this.search.not_service_period_start = ''
      this.search.not_service_period_end = ''
      this.search.not_administrative_expense = ''
      this.search.not_first_month_deposit = ''
      this.watch.not_first_month_deposit_method = 0
      this.search.not_first_month_deposit_check = ''
      this.search.not_admission_fee = ''
      this.watch.not_admission_fee_method = 0
      this.search.not_admission_fee_check = ''
      this.watch.not_deposit = 0
      this.watch.not_deposit_method = 0
      this.search.not_deposit_check = ''
      this.search.not_bank_number = ''
      this.search.not_branch_number = ''
      this.watch.not_deposit_item = 0
      this.search.not_account_number = ''
      this.search.not_account_holder = ''
      this.search.not_expected_refund_date = ''
      this.search.not_deposit_refund_date = ''
      this.search.not_approval_date = ''
      this.search.not_approval_number = ''
      this.search.not_delivery_date = ''
      this.search.not_contract_collection_date = ''
      this.search.not_factor_collection_date = ''
      this.watch.not_factor_check = 0
      this.watch.not_ledger_check = 0
      this.watch.not_cancel_check = 0
      this.watch.not_change_check = 0
      this.search.not_grade = ''
      this.search.not_point_s = ''
      this.search.not_point_c = ''
      this.search.not_point_k = ''
      this.search.not_point_s_bulk = ''
      this.search.not_point_c_bulk = ''
      this.search.not_point_k_bulk = ''
      this.search.not_point_total = ''
      this.search.not_note = ''

      this.searchTable()
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // alert('get')
      let getjson = localStorage.getItem('AgreementsSearch')
      let obj = JSON.parse(getjson)

      vm.watch.tag_id = obj['tag_id']
      vm.search.payroll_check = obj['payroll_check']
      vm.search.id = obj['id']
      vm.search.student_id = obj['student_id']
      vm.watch.office_id = obj['office_id']
      vm.watch.user_id = obj['user_id']
      vm.watch.contract_type = obj['contract_type']
      vm.search.contract_date = obj['contract_date']
      vm.search.change_date = obj['change_date']
      vm.watch.cancel_type = obj['cancel_type']
      vm.search.cancel_date = obj['cancel_date']
      vm.search.f_name = obj['f_name']
      vm.search.l_name = obj['l_name']
      vm.search.f_name_kana = obj['f_name_kana']
      vm.search.l_name_kana = obj['l_name_kana']
      vm.search.tel = obj['tel']
      vm.search.tel2 = obj['tel2']
      vm.search.address = obj['address']
      vm.search.address2 = obj['address2']
      vm.search.birthday = obj['birthday']
      vm.search.hourly_pay = obj['hourly_pay']
      vm.search.amount = obj['amount']
      vm.search.discount = obj['discount']
      vm.search.split_commission = obj['split_commission']
      vm.search.sales_commission = obj['sales_commission']
      vm.search.sales_commission_head = obj['sales_commission_head']
      vm.search.sales_commission_branch = obj['sales_commission_branch']
      vm.search.old_amount = obj['old_amount']
      vm.search.agency_commission = obj['agency_commission']
      vm.search.agency_commission_head = obj['agency_commission_head']
      vm.search.agency_commission_branch = obj['agency_commission_branch']
      vm.search.purchase_amount = obj['purchase_amount']
      vm.search.purchase_amount_head = obj['purchase_amount_head']
      vm.search.purchase_amount_branch = obj['purchase_amount_branch']
      vm.search.only_total_amount = obj['only_total_amount']
      vm.search.only_total_amount_head = obj['only_total_amount_head']
      vm.search.only_total_amount_branch = obj['only_total_amount_branch']
      vm.search.down_payment = obj['down_payment']
      vm.search.deposit_amount = obj['deposit_amount']
      vm.search.person = obj['person']
      vm.search.product_name = obj['product_name']
      vm.watch.payment_type = obj['payment_type']
      vm.watch.payments_number = obj['payments_number']
      vm.search.deposit_amount_date = obj['deposit_amount_date']
      vm.watch.text_type = obj['text_type']
      vm.search.amount = obj['amount']
      vm.search.discount = obj['discount']
      vm.search.pure_amount = obj['pure_amount']
      vm.search.division_commission = obj['division_commission']
      vm.search.total_amount = obj['total_amount']
      vm.search.text_grade_number = obj['text_grade_number']
      vm.search.text_payment_period_start = obj['text_payment_period_start']
      vm.search.text_payment_period_end = obj['text_payment_period_end']
      vm.search.service_period_start = obj['service_period_start']
      vm.search.service_period_end = obj['service_period_end']
      vm.search.administrative_expense = obj['administrative_expense']
      vm.search.first_month_deposit = obj['first_month_deposit']
      vm.watch.first_month_deposit_method = obj['first_month_deposit_method']
      vm.search.first_month_deposit_check = obj['first_month_deposit_check']
      vm.search.admission_fee = obj['admission_fee']
      vm.watch.admission_fee_method = obj['admission_fee_method']
      vm.search.admission_fee_check = obj['admission_fee_check']
      vm.search.deposit = obj['deposit']
      vm.watch.deposit_method = obj['deposit_method']
      vm.search.deposit_check = obj['deposit_check']
      vm.search.bank_number = obj['bank_number']
      vm.search.branch_number = obj['branch_number']
      vm.watch.deposit_item = obj['deposit_item']
      vm.search.account_number = obj['account_number']
      vm.search.account_holder = obj['account_holder']
      vm.search.expected_refund_date = obj['expected_refund_date']
      vm.search.deposit_refund_date = obj['deposit_refund_date']
      vm.search.approval_date = obj['approval_date']
      vm.search.approval_number = obj['approval_number']
      vm.search.delivery_date = obj['delivery_date']
      vm.search.contract_collection_date = obj['contract_collection_date']
      vm.search.factor_collection_date = obj['factor_collection_date']
      vm.watch.factor_check = obj['factor_check']
      vm.watch.ledger_check = obj['ledger_check']
      vm.watch.cancel_check = obj['cancel_check']
      vm.watch.change_check = obj['change_check']
      vm.search.grade = obj['grade']
      vm.search.point_s = obj['point_s']
      vm.search.point_c = obj['point_c']
      vm.search.point_k = obj['point_k']
      vm.search.point_s_bulk = obj['point_s_bulk']
      vm.search.point_c_bulk = obj['point_c_bulk']
      vm.search.point_k_bulk = obj['point_k_bulk']
      vm.search.point_total = obj['point_total']
      vm.search.note = obj['note']
      vm.search.created_at = obj['created_at']
      vm.search.updated_at = obj['updated_at']

      vm.watch.not_tag_id = obj['not_tag_id']
      vm.search.not_payroll_check = obj['not_payroll_check']
      vm.search.not_id = obj['not_id']
      vm.search.not_student_id = obj['not_student_id']
      vm.watch.not_office_id = obj['not_office_id']
      vm.watch.not_user_id = obj['not_user_id']
      vm.watch.not_contract_type = obj['not_contract_type']
      vm.search.not_contract_date = obj['not_contract_date']
      vm.search.not_change_date = obj['not_change_date']
      vm.watch.not_cancel_type = obj['not_cancel_type']
      vm.search.not_cancel_date = obj['not_cancel_date']
      vm.search.not_f_name = obj['not_f_name']
      vm.search.not_l_name = obj['not_l_name']
      vm.search.not_f_name_kana = obj['not_f_name_kana']
      vm.search.not_l_name_kana = obj['not_l_name_kana']
      vm.search.not_tel = obj['not_tel']
      vm.search.not_tel2 = obj['not_tel2']
      vm.search.not_address = obj['not_address']
      vm.search.not_address2 = obj['not_address2']
      vm.search.not_birthday = obj['not_birthday']
      vm.search.not_hourly_pay = obj['not_hourly_pay']
      vm.search.not_amount = obj['not_amount']
      vm.search.not_discount = obj['not_discount']
      vm.search.not_split_commission = obj['not_split_commission']
      vm.search.not_sales_commission = obj['not_sales_commission']
      vm.search.not_sales_commission_head = obj['not_sales_commission_head']
      vm.search.not_sales_commission_branch = obj['not_sales_commission_branch']
      vm.search.not_old_amount = obj['not_old_amount']
      vm.search.not_agency_commission = obj['not_agency_commission']
      vm.search.not_agency_commission_head = obj['not_agency_commission_head']
      vm.search.not_agency_commission_branch = obj['not_agency_commission_branch']
      vm.search.not_purchase_amount = obj['not_purchase_amount']
      vm.search.not_purchase_amount_head = obj['not_purchase_amount_head']
      vm.search.not_purchase_amount_branch = obj['not_purchase_amount_branch']
      vm.search.not_only_total_amount = obj['not_only_total_amount']
      vm.search.not_only_total_amount_head = obj['not_only_total_amount_head']
      vm.search.not_only_total_amount_branch = obj['not_only_total_amount_branch']
      vm.search.not_down_payment = obj['not_down_payment']
      vm.search.not_deposit_amount = obj['not_deposit_amount']
      vm.search.not_deposit_amount_date = obj['not_deposit_amount_date']
      vm.search.not_person = obj['not_person']
      vm.search.not_product_name = obj['not_product_name']
      vm.watch.not_payment_type = obj['not_payment_type']
      vm.watch.not_payments_number = obj['not_payments_number']
      vm.watch.not_text_type = obj['not_text_type']
      vm.search.not_amount = obj['not_amount']
      vm.search.not_discount = obj['not_discount']
      vm.search.not_pure_amount = obj['not_pure_amount']
      vm.search.not_division_commission = obj['not_division_commission']
      vm.search.not_total_amount = obj['not_total_amount']
      vm.search.not_text_grade_number = obj['not_text_grade_number']
      vm.search.not_text_payment_period_start = obj['not_text_payment_period_start']
      vm.search.not_text_payment_period_end = obj['not_text_payment_period_end']
      vm.search.not_service_period_start = obj['not_service_period_start']
      vm.search.not_service_period_end = obj['not_service_period_end']
      vm.search.not_administrative_expense = obj['not_administrative_expense']
      vm.search.not_first_month_deposit = obj['not_first_month_deposit']
      vm.watch.not_first_month_deposit_method = obj['not_first_month_deposit_method']
      vm.search.not_first_month_deposit_check = obj['not_first_month_deposit_check']
      vm.search.not_admission_fee = obj['not_admission_fee']
      vm.watch.not_admission_fee_method = obj['not_admission_fee_method']
      vm.search.not_admission_fee_check = obj['not_admission_fee_check']
      vm.watch.not_deposit = obj['not_deposit']
      vm.watch.not_deposit_method = obj['not_deposit_method']
      vm.search.not_deposit_check = obj['not_deposit_check']
      vm.search.not_bank_number = obj['not_bank_number']
      vm.search.not_branch_number = obj['not_branch_number']
      vm.watch.not_deposit_item = obj['not_deposit_item']
      vm.search.not_account_number = obj['not_account_number']
      vm.search.not_account_holder = obj['not_account_holder']
      vm.search.not_expected_refund_date = obj['not_expected_refund_date']
      vm.search.not_deposit_refund_date = obj['not_deposit_refund_date']
      vm.search.not_approval_date = obj['not_approval_date']
      vm.search.not_approval_number = obj['not_approval_number']
      vm.search.not_delivery_date = obj['not_delivery_date']
      vm.search.not_contract_collection_date = obj['not_contract_collection_date']
      vm.search.not_factor_collection_date = obj['not_factor_collection_date']
      vm.watch.not_factor_check = obj['not_factor_check']
      vm.watch.not_ledger_check = obj['not_ledger_check']
      vm.watch.not_cancel_check = obj['not_cancel_check']
      vm.watch.not_change_check = obj['not_change_check']
      vm.search.not_grade = obj['not_grade']
      vm.search.not_point_s = obj['not_point_s']
      vm.search.not_point_c = obj['not_point_c']
      vm.search.not_point_k = obj['not_point_k']
      vm.search.not_point_s_bulk = obj['not_point_s_bulk']
      vm.search.not_point_c_bulk = obj['not_point_c_bulk']
      vm.search.not_point_k_bulk = obj['not_point_k_bulk']
      vm.search.not_point_total = obj['not_point_total']
      vm.search.not_note = obj['not_note']
      vm.search.not_created_at = obj['not_created_at']
      vm.search.not_updated_at = obj['not_updated_at']

      vm.color = obj['column_color']
      vm.tag_id = obj['column_tag_id']
      vm.payroll_check = obj['column_payroll_check']
      vm.id = obj['column_id']
      vm.student_id = obj['column_student_id']
      vm.office_id = obj['column_office_id']
      vm.user_id = obj['column_user_id']
      vm.contract_type = obj['column_contract_type']
      vm.contract_date = obj['column_contract_date']
      vm.change_date = obj['column_change_date']
      vm.cancel_type = obj['column_cancel_type']
      vm.cancel_date = obj['column_cancel_date']
      vm.f_name = obj['column_f_name']
      vm.l_name = obj['column_l_name']
      vm.f_name_kana = obj['column_f_name_kana']
      vm.l_name_kana = obj['column_l_name_kana']
      vm.tel = obj['column_tel']
      vm.tel2 = obj['column_tel2']
      vm.address = obj['column_address']
      vm.address2 = obj['column_address2']
      vm.birthday = obj['column_birthday']
      vm.hourly_pay = obj['column_hourly_pay']
      vm.amount = obj['column_amount']
      vm.discount = obj['column_discount']
      vm.split_commission = obj['column_split_commission']
      vm.sales_commission = obj['column_sales_commission']
      vm.sales_commission_head = obj['column_sales_commission_head']
      vm.sales_commission_branch = obj['column_sales_commission_branch']
      vm.old_amount = obj['column_old_amount']
      vm.agency_commission = obj['column_agency_commission']
      vm.agency_commission_head = obj['column_agency_commission_head']
      vm.agency_commission_branch = obj['column_agency_commission_branch']
      vm.purchase_amount = obj['column_purchase_amount']
      vm.purchase_amount_head = obj['column_purchase_amount_head']
      vm.purchase_amount_branch = obj['column_purchase_amount_branch']
      vm.only_total_amount = obj['column_only_total_amount']
      vm.only_total_amount_head = obj['column_only_total_amount_head']
      vm.only_total_amount_branch = obj['column_only_total_amount_branch']
      vm.down_payment = obj['column_down_payment']
      vm.deposit_amount = obj['column_deposit_amount']
      vm.person = obj['column_person']
      vm.product_name = obj['column_product_name']
      vm.payment_type = obj['column_payment_type']
      vm.payments_number = obj['column_payments_number']
      vm.deposit_amount_date = obj['column_deposit_amount_date']
      vm.text_type = obj['column_text_type']
      vm.amount = obj['column_amount']
      vm.discount = obj['column_discount']
      vm.pure_amount = obj['column_pure_amount']
      vm.division_commission = obj['column_division_commission']
      vm.total_amount = obj['column_total_amount']
      vm.text_grade_number = obj['column_text_grade_number']
      vm.text_payment_period_start = obj['column_text_payment_period_start']
      vm.text_payment_period_end = obj['column_text_payment_period_end']
      vm.service_period_start = obj['column_service_period_start']
      vm.service_period_end = obj['column_service_period_end']
      vm.administrative_expense = obj['column_administrative_expense']
      vm.first_month_deposit = obj['column_first_month_deposit']
      vm.first_month_deposit_method = obj['column_first_month_deposit_method']
      vm.first_month_deposit_check = obj['column_first_month_deposit_check']
      vm.admission_fee = obj['column_admission_fee']
      vm.admission_fee_method = obj['column_admission_fee_method']
      vm.admission_fee_check = obj['column_admission_fee_check']
      vm.deposit = obj['column_deposit']
      vm.deposit_method = obj['column_deposit_method']
      vm.deposit_check = obj['column_deposit_check']
      vm.bank_number = obj['column_bank_number']
      vm.branch_number = obj['column_branch_number']
      vm.deposit_item = obj['column_deposit_item']
      vm.account_number = obj['column_account_number']
      vm.account_holder = obj['column_account_holder']
      vm.expected_refund_date = obj['column_expected_refund_date']
      vm.deposit_refund_date = obj['column_deposit_refund_date']
      vm.approval_date = obj['column_approval_date']
      vm.approval_number = obj['column_approval_number']
      vm.delivery_date = obj['column_delivery_date']
      vm.contract_collection_date = obj['column_contract_collection_date']
      vm.factor_collection_date = obj['column_factor_collection_date']
      vm.factor_check = obj['column_factor_check']
      vm.ledger_check = obj['column_ledger_check']
      vm.cancel_check = obj['column_cancel_check']
      vm.change_check = obj['column_change_check']
      vm.grade = obj['column_grade']
      vm.point_s = obj['column_point_s']
      vm.point_c = obj['column_point_c']
      vm.point_k = obj['column_point_k']
      vm.point_s_bulk = obj['column_point_s_bulk']
      vm.point_c_bulk = obj['column_point_c_bulk']
      vm.point_k_bulk = obj['column_point_k_bulk']
      vm.point_total = obj['column_point_total']
      vm.note = obj['column_note']
      vm.created_at = obj['column_created_at']
      vm.updated_at = obj['column_updated_at']

      // console.log(obj)
      vm.searchTable()
    })
  },
  beforeRouteLeave (to, from, next) {
    // alert('save')
    let arr = []
    let obj = {

      tag_id: this.watch.tag_id,
      payroll_check: this.search.payroll_check,
      id: this.search.id,
      student_id: this.search.student_id,
      office_id: this.watch.office_id,
      user_id: this.watch.user_id,
      contract_type: this.watch.contract_type,
      contract_date: this.search.contract_date,
      change_date: this.search.change_date,
      cancel_type: this.watch.cancel_type,
      cancel_date: this.search.cancel_date,
      f_name: this.search.f_name,
      l_name: this.search.l_name,
      f_name_kana: this.search.f_name_kana,
      l_name_kana: this.search.l_name_kana,
      tel: this.search.tel,
      tel2: this.search.tel2,
      address: this.search.address,
      address2: this.search.address2,
      birthday: this.search.birthday,
      hourly_pay: this.search.hourly_pay,
      split_commission: this.search.split_commission,
      sales_commission: this.search.sales_commission,
      sales_commission_head: this.search.sales_commission_head,
      sales_commission_branch: this.search.sales_commission_branch,
      old_amount: this.search.old_amount,
      agency_commission: this.search.agency_commission,
      agency_commission_head: this.search.agency_commission_head,
      agency_commission_branch: this.search.agency_commission_branch,
      purchase_amount: this.search.purchase_amount,
      purchase_amount_head: this.search.purchase_amount_head,
      purchase_amount_branch: this.search.purchase_amount_branch,
      only_total_amount: this.search.only_total_amount,
      only_total_amount_head: this.search.only_total_amount_head,
      only_total_amount_branch: this.search.only_total_amount_branch,
      down_payment: this.search.down_payment,
      deposit_amount: this.search.deposit_amount,
      person: this.search.person,
      product_name: this.search.product_name,
      payment_type: this.watch.payment_type,
      payments_number: this.watch.payments_number,
      deposit_amount_date: this.search.deposit_amount_date,
      text_type: this.watch.text_type,
      amount: this.search.amount,
      discount: this.search.discount,
      pure_amount: this.search.pure_amount,
      division_commission: this.search.division_commission,
      total_amount: this.search.total_amount,
      text_grade_number: this.search.text_grade_number,
      text_payment_period_start: this.search.text_payment_period_start,
      text_payment_period_end: this.search.text_payment_period_end,
      service_period_start: this.search.service_period_start,
      service_period_end: this.search.service_period_end,
      administrative_expense: this.search.administrative_expense,
      first_month_deposit: this.search.first_month_deposit,
      first_month_deposit_method: this.watch.first_month_deposit_method,
      first_month_deposit_check: this.search.first_month_deposit_check,
      admission_fee: this.search.admission_fee,
      admission_fee_method: this.watch.admission_fee_method,
      admission_fee_check: this.search.admission_fee_check,
      deposit: this.search.deposit,
      deposit_method: this.watch.deposit_method,
      deposit_check: this.search.deposit_check,
      bank_number: this.search.bank_number,
      branch_number: this.search.branch_number,
      deposit_item: this.watch.deposit_item,
      account_number: this.search.account_number,
      account_holder: this.search.account_holder,
      expected_refund_date: this.search.expected_refund_date,
      deposit_refund_date: this.search.deposit_refund_date,
      approval_date: this.search.approval_date,
      approval_number: this.search.approval_number,
      delivery_date: this.search.delivery_date,
      contract_collection_date: this.search.contract_collection_date,
      factor_collection_date: this.search.factor_collection_date,
      factor_check: this.watch.factor_check,
      ledger_check: this.watch.ledger_check,
      cancel_check: this.watch.cancel_check,
      change_check: this.watch.change_check,
      grade: this.search.grade,
      point_s: this.search.point_s,
      point_c: this.search.point_c,
      point_k: this.search.point_k,
      point_s_bulk: this.search.point_s_bulk,
      point_c_bulk: this.search.point_c_bulk,
      point_k_bulk: this.search.point_k_bulk,
      point_total: this.search.point_total,
      note: this.search.note,
      created_at: this.search.created_at,
      updated_at: this.search.updated_at,

      not_tag_id: this.watch.not_tag_id,
      not_payroll_check: this.search.not_payroll_check,
      not_id: this.search.not_id,
      not_student_id: this.search.not_student_id,
      not_office_id: this.watch.not_office_id,
      not_user_id: this.watch.not_user_id,
      not_contract_type: this.watch.not_contract_type,
      not_contract_date: this.search.not_contract_date,
      not_change_date: this.search.not_change_date,
      not_cancel_type: this.watch.not_cancel_type,
      not_cancel_date: this.search.not_cancel_date,
      not_f_name: this.search.not_f_name,
      not_l_name: this.search.not_l_name,
      not_f_name_kana: this.search.not_f_name_kana,
      not_l_name_kana: this.search.not_l_name_kana,
      not_tel: this.search.not_tel,
      not_tel2: this.search.not_tel2,
      not_address: this.search.not_address,
      not_address2: this.search.not_address2,
      not_birthday: this.search.not_birthday,
      not_hourly_pay: this.search.not_hourly_pay,
      not_split_commission: this.search.not_split_commission,
      not_sales_commission: this.search.not_sales_commission,
      not_sales_commission_head: this.search.not_sales_commission_head,
      not_sales_commission_branch: this.search.not_sales_commission_branch,
      not_old_amount: this.search.not_old_amount,
      not_agency_commission: this.search.not_agency_commission,
      not_agency_commission_head: this.search.not_agency_commission_head,
      not_agency_commission_branch: this.search.not_agency_commission_branch,
      not_purchase_amount: this.search.not_purchase_amount,
      not_purchase_amount_head: this.search.not_purchase_amount_head,
      not_purchase_amount_branch: this.search.not_purchase_amount_branch,
      not_only_total_amount: this.search.not_only_total_amount,
      not_only_total_amount_head: this.search.not_only_total_amount_head,
      not_only_total_amount_branch: this.search.not_only_total_amount_branch,
      not_down_payment: this.search.not_down_payment,
      not_deposit_amount: this.search.not_deposit_amount,
      not_deposit_amount_date: this.search.not_deposit_amount_date,
      not_person: this.search.not_person,
      not_product_name: this.search.not_product_name,
      not_payment_type: this.watch.not_payment_type,
      not_payments_number: this.watch.not_payments_number,
      not_text_type: this.watch.not_text_type,
      not_amount: this.search.not_amount,
      not_discount: this.search.not_discount,
      not_pure_amount: this.search.not_pure_amount,
      not_division_commission: this.search.not_division_commission,
      not_total_amount: this.search.not_total_amount,
      not_text_grade_number: this.search.not_text_grade_number,
      not_text_payment_period_start: this.search.not_text_payment_period_start,
      not_text_payment_period_end: this.search.not_text_payment_period_end,
      not_service_period_start: this.search.not_service_period_start,
      not_service_period_end: this.search.not_service_period_end,
      not_administrative_expense: this.search.not_administrative_expense,
      not_first_month_deposit: this.search.not_first_month_deposit,
      not_first_month_deposit_method: this.watch.not_first_month_deposit_method,
      not_first_month_deposit_check: this.search.not_first_month_deposit_check,
      not_admission_fee: this.search.not_admission_fee,
      not_admission_fee_method: this.watch.not_admission_fee_method,
      not_admission_fee_check: this.search.not_admission_fee_check,
      not_deposit: this.watch.not_deposit,
      not_deposit_method: this.watch.not_deposit_method,
      not_deposit_check: this.search.not_deposit_check,
      not_bank_number: this.search.not_bank_number,
      not_branch_number: this.search.not_branch_number,
      not_deposit_item: this.watch.not_deposit_item,
      not_account_number: this.search.not_account_number,
      not_account_holder: this.search.not_account_holder,
      not_expected_refund_date: this.search.not_expected_refund_date,
      not_deposit_refund_date: this.search.not_deposit_refund_date,
      not_approval_date: this.search.not_approval_date,
      not_approval_number: this.search.not_approval_number,
      not_delivery_date: this.search.not_delivery_date,
      not_contract_collection_date: this.search.not_contract_collection_date,
      not_factor_collection_date: this.search.not_factor_collection_date,
      not_factor_check: this.watch.not_factor_check,
      not_ledger_check: this.watch.not_ledger_check,
      not_cancel_check: this.watch.not_cancel_check,
      not_change_check: this.watch.not_change_check,
      not_grade: this.search.not_grade,
      not_point_s: this.search.not_point_s,
      not_point_c: this.search.not_point_c,
      not_point_k: this.search.not_point_k,
      not_point_s_bulk: this.search.not_point_s_bulk,
      not_point_c_bulk: this.search.not_point_c_bulk,
      not_point_k_bulk: this.search.not_point_k_bulk,
      not_point_total: this.search.not_point_total,
      not_note: this.search.not_note,
      not_created_at: this.search.not_created_at,
      not_updated_at: this.search.not_updated_at,

      column_color: this.color,
      column_tag_id: this.tag_id,
      column_payroll_check: this.payroll_check,
      column_id: this.id,
      column_student_id: this.student_id,
      column_office_id: this.office_id,
      column_user_id: this.user_id,
      column_contract_type: this.contract_type,
      column_contract_date: this.contract_date,
      column_change_date: this.change_date,
      column_cancel_type: this.cancel_type,
      column_cancel_date: this.cancel_date,
      column_f_name: this.f_name,
      column_l_name: this.l_name,
      column_f_name_kana: this.f_name_kana,
      column_l_name_kana: this.l_name_kana,
      column_tel: this.tel,
      column_tel2: this.tel2,
      column_address: this.address,
      column_address2: this.address2,
      column_birthday: this.birthday,
      column_hourly_pay: this.hourly_pay,
      column_split_commission: this.split_commission,
      column_sales_commission: this.sales_commission,
      column_sales_commission_head: this.sales_commission_head,
      column_sales_commission_branch: this.sales_commission_branch,
      column_old_amount: this.old_amount,
      column_agency_commission: this.agency_commission,
      column_agency_commission_head: this.agency_commission_head,
      column_agency_commission_branch: this.agency_commission_branch,
      column_purchase_amount: this.purchase_amount,
      column_purchase_amount_head: this.purchase_amount_head,
      column_purchase_amount_branch: this.purchase_amount_branch,
      column_only_total_amount: this.only_total_amount,
      column_only_total_amount_head: this.only_total_amount_head,
      column_only_total_amount_branch: this.only_total_amount_branch,
      column_down_payment: this.down_payment,
      column_deposit_amount: this.deposit_amount,
      column_person: this.person,
      column_product_name: this.product_name,
      column_payment_type: this.payment_type,
      column_payments_number: this.payments_number,
      column_deposit_amount_date: this.deposit_amount_date,
      column_text_type: this.text_type,
      column_amount: this.amount,
      column_discount: this.discount,
      column_pure_amount: this.pure_amount,
      column_division_commission: this.division_commission,
      column_total_amount: this.total_amount,
      column_text_grade_number: this.text_grade_number,
      column_text_payment_period_start: this.text_payment_period_start,
      column_text_payment_period_end: this.text_payment_period_end,
      column_service_period_start: this.service_period_start,
      column_service_period_end: this.service_period_end,
      column_administrative_expense: this.administrative_expense,
      column_first_month_deposit: this.first_month_deposit,
      column_first_month_deposit_method: this.first_month_deposit_method,
      column_first_month_deposit_check: this.first_month_deposit_check,
      column_admission_fee: this.admission_fee,
      column_admission_fee_method: this.admission_fee_method,
      column_admission_fee_check: this.admission_fee_check,
      column_deposit: this.deposit,
      column_deposit_method: this.deposit_method,
      column_deposit_check: this.deposit_check,
      column_bank_number: this.bank_number,
      column_branch_number: this.branch_number,
      column_deposit_item: this.deposit_item,
      column_account_number: this.account_number,
      column_account_holder: this.account_holder,
      column_expected_refund_date: this.expected_refund_date,
      column_deposit_refund_date: this.deposit_refund_date,
      column_approval_date: this.approval_date,
      column_approval_number: this.approval_number,
      column_delivery_date: this.delivery_date,
      column_contract_collection_date: this.contract_collection_date,
      column_factor_collection_date: this.factor_collection_date,
      column_factor_check: this.factor_check,
      column_ledger_check: this.ledger_check,
      column_cancel_check: this.cancel_check,
      column_change_check: this.change_check,
      column_grade: this.grade,
      column_point_s: this.point_s,
      column_point_c: this.point_c,
      column_point_k: this.point_k,
      column_point_s_bulk: this.point_s_bulk,
      column_point_c_bulk: this.point_c_bulk,
      column_point_k_bulk: this.point_k_bulk,
      column_point_total: this.point_total,
      column_note: this.note,
      column_created_at: this.created_at,
      column_updated_at: this.updated_at
    }
    arr.push(obj)
    let setjson = JSON.stringify(obj)
    localStorage.setItem('AgreementsSearch', setjson)
    next()
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss" scoped>
.sticky-1 {
  position: sticky;
  z-index: 4;
  top: 0;
  background: #fff;
  &:before {
    content: '';
    position: absolute;
    display: block;
    background: #ccc;
    height: 1px;
    width: 100%;
    left: 0;
    top: -1px;
  }
  &:after {
    content: '';
    position: absolute;
    display: block;
    background: #ccc;
    height: 1px;
    width: 100%;
    left: 0;
    bottom: -1px;
  }
}
.sticky-2 {
  position: sticky;
  z-index: 3;
  top: 26px;
  background: #fff;
  &:before {
    content: '';
    position: absolute;
    display: block;
    background: #ccc;
    height: 1px;
    width: 100%;
    left: 0;
    bottom: -1px;
  }
}
.sticky-3 {
  position: sticky;
  z-index: 2;
  top: 52px;
  &:before {
    content: '';
    position: absolute;
    display: block;
    background: #ccc;
    height: 1px;
    width: 100%;
    left: 0;
    bottom: -1px;
  }
}

.m-label-custom {
  z-index: 1;
  cursor: pointer;
  margin-bottom: 1px;
}
.slideActive {
  background: #455A64;
  color: #fff;
}
.active {
  background: #455A64;
  border: solid 1px #455A64;
  color: #fff;
}
.resetSearch {
  padding: 7px 0;
}
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
.select {
  padding: 0 !important;
}
input {
  width: 100%;
  min-width: 100px;
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
}
.index-box {
  height: calc(100vh - 195px);
  overflow: scroll;
  margin-top: 10px;
  &:after {
    content: "\f2b5";
    font-family: FontAwesome;
    position: absolute;
    font-size: 500px;
    top: 50%;
    left: 50%;
    margin-top: -250px;
    margin-left: -250px;
    color: #ddd;
    opacity: 0.1;
    z-index: -1;
  }
}
.del {
  text-align: center;
  cursor: pointer;
  &:hover {
    background: black;
    color: white;
  }
}

.blue {
  background: #1E90FF;
  color: #000;
}
.orange {
  background: #F4A460;
  color: #000;
}
.green {
  background: #90EE90;
  color: #000;
}
.purple {
  background: #DA70D6;
  color: #000;
}
.DarkBlue {
  background: #B0C4DE;
  color: #000;
}
.yellow {
  background: #F0E68C;
  color: #000;
}
</style>

<style lang="scss">
.AgreementsIndex {
  .multiselect {
    min-height: 23px;
    min-width: 110px;
  }
  .multiselect__tag {
    margin: 1px;
    font-size: 10px;
  }
  .multiselect__tag-icon {
    line-height: 18px;
    &:after {
      font-size: 10px;
    }
  }
  .multiselect__tags {
    border: solid 1px #ccc;
    min-height: 23px;
    padding: 0px 23px 0 2px;
    border-radius: 0;
    border: none;
    margin: 3px 1px 1px 1px;
  }
  .multiselect__tags-wrap {
    /* background: red; */
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 23px;
  }
  .multiselect__select {
    height: 23px;
    width: 26px;
    top: 2px;
    padding: 0;
    &:before {
      top: 65%;
    }
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// AgreementsIndex.vue?06da2a33